{
  "common": {
    "appName": "atsume.camp",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "loading": "Loading…",
    "language": "Language"
  },
  "nav": {
    "dashboard": "Dashboard",
    "camps": "Tours",
    "partners": "Partners",
    "timeline": "Timeline",
    "inquiries": "Inbox",
    "forms": "Forms",
    "settings": "Settings",
    "admin": "Admin"
  },
  "camps": {
    "title": "Tours",
    "new": "New tour",
    "searchPlaceholder": "Search…",
    "filterAll": "All",
    "selectedCount": "{{count}} selected",
    "changeStatus": "Change status",
    "clearSelection": "Clear",
    "emptyFiltered": "No matching tours.",
    "datesTbd": "TBD",
    "cols": {
      "status": "Status",
      "name": "Tour",
      "client": "Client",
      "destination": "Destination",
      "dates": "Dates",
      "pax": "Travelers",
      "budget": "Budget",
      "progress": "Progress"
    },
    "destination": "Destination",
    "startDate": "Start date",
    "endDate": "End date",
    "pax": "Travelers",
    "empty": "No tours yet. Create your first one.",
    "status": {
      "inquiry": "Inquiry",
      "negotiating": "In talks",
      "likely": "Likely",
      "confirmed": "Confirmed",
      "active": "On tour",
      "settling": "Settling",
      "settled": "Final check",
      "completed": "Completed"
    },
    "deleteConfirm": "Delete {{count}} camps? This action cannot be undone.",
    "countItems": "{{count}}",
    "destinationTbd": "Destination TBD",
    "paxCount": "{{count}}"
  },
  "campCreate": {
    "title": "Create tour",
    "description": "Enter a prompt for AI, or fill in the form manually.",
    "aiMode": "AI mode",
    "manualMode": "Manual",
    "promptLabel": "Prompt",
    "promptPlaceholder": "e.g. A 40-person Australian football team wants to visit Tokyo for a week. 2 matches + cultural experiences + team building. Budget around ¥450k per person.",
    "aiNote": "AI generation coming soon. For now we create from keyword extraction.",
    "creating": "Creating…",
    "createByKeyword": "Create from keywords",
    "nameLabel": "Tour name",
    "namePlaceholder": "e.g. AUS football team — Tokyo tour",
    "clientName": "Client name",
    "clientOrg": "Client organization",
    "destinationLabel": "Destination",
    "destinationPlaceholder": "e.g. Tokyo, Yokohama",
    "startDate": "Start date",
    "endDate": "End date",
    "budgetLabel": "Budget",
    "pax": {
      "adult": "Adults",
      "adult2": "Adults ②",
      "child": "Children",
      "infant": "Infants",
      "other": "Other"
    },
    "tenantNotSelected": "No tenant selected",
    "aiFailed": "AI generation failed. Created via local parsing.",
    "errors": {
      "nameRequired": "Tour name is required",
      "nonNegative": "Enter a number ≥ 0"
    }
  },
  "dashboard": {
    "viewTableKpi": "Table · KPI",
    "viewKanban": "Kanban",
    "viewGantt": "Gantt · Editorial",
    "tabUpcoming": "Upcoming",
    "tabActive": "Active",
    "tabCompleted": "Completed",
    "searchPlaceholder": "Search tours…",
    "selectPrompt": "Select a tour",
    "pipelineAndTimeline": "Pipeline & timeline",
    "campMenu": "Menu for \"{{name}}\"",
    "deleteCampTitle": "Delete this tour?",
    "deleteCampBody": "\"{{name}}\" and all its data (participants, itinerary, tasks…) will be deleted. This cannot be undone.",
    "duplicate": "Duplicate",
    "progress": "Progress",
    "nightsDays": "{{nights}}N {{days}}D",
    "countCamps": "{{count}} tours",
    "viewOverview": "Overview",
    "viewPipeline": "Pipeline",
    "viewSeason": "Season",
    "inFlight": "In flight",
    "pipelineValue": "Pipeline value",
    "confirmedPax": "Confirmed pax",
    "avgProgress": "Avg progress",
    "atRisk": "At risk",
    "pipeline": "Pipeline",
    "inFlightAmount": "{{amount}} in flight",
    "thisSeason": "This season",
    "pax": "Pax"
  },
  "settings": {
    "profile": "Profile",
    "emailAddress": "Email address",
    "displayName": "Display name",
    "notSet": "Not set",
    "tenant": "Tenant",
    "tenantNameLabel": "Tenant name (shown at the top-left of the sidebar)",
    "tenantNamePlaceholder": "Acme Inc.",
    "logoImageLabel": "Logo image (square recommended, PNG / JPG / WebP / SVG, max 2MB)",
    "changeImage": "Change image",
    "uploadImage": "Upload image",
    "removeImage": "Remove image",
    "closeUrlInput": "Close URL input",
    "specifyByUrl": "Specify by URL (external image)",
    "savedConfirmation": "Saved ✓",
    "theme": "Theme",
    "darkMode": "Dark mode",
    "darkModeEnabled": "Dark mode is enabled",
    "lightModeEnabled": "Light mode is enabled",
    "notifications": "Notification settings",
    "emailNotifications": "Email notifications",
    "emailNotificationsDesc": "Receive camp updates and reminders by email",
    "appInfo": "App info",
    "version": "Version",
    "environment": "Environment",
    "support": "Support",
    "errorSelectImageFile": "Please select an image file",
    "errorFileSizeLimit": "File size must be 2MB or less",
    "errorUploadFailed": "Upload failed: {{message}}",
    "errorTenantNameRequired": "Tenant name is required"
  },
  "inquiries": {
    "title": "Inquiries",
    "subtitle": "Review inquiries from your public form and convert them into dated training sessions or tours.",
    "filter": {
      "status": "Status",
      "kind": "Interest",
      "all": "All"
    },
    "status": {
      "new": "New",
      "contacted": "Contacted",
      "proposing": "Proposing",
      "converted": "Converted",
      "declined": "Declined"
    },
    "kind": {
      "training": "Training",
      "tour": "Tour",
      "retreat": "Retreat",
      "other": "Other",
      "undecided": "Undecided"
    },
    "empty": "No matching inquiries",
    "table": {
      "receivedAt": "Received",
      "nameCompany": "Name / Company",
      "contact": "Contact",
      "dateHeadcount": "Dates / Headcount",
      "source": "Source",
      "actions": "Actions"
    },
    "headcountUnit": "{{count}} people",
    "convert": "Convert",
    "dialog": {
      "title": "Convert to training / tour",
      "description": "Create a dated camp from this inquiry. You can create multiple camps (different schedules) from the same inquiry.",
      "created": "Camp created.",
      "formUrl": "Application form URL",
      "copy": "Copy",
      "noForm": "No application form was created (you can issue one later from the forms screen).",
      "openCamp": "Open camp",
      "done": "Done",
      "campName": "Camp name",
      "kind": "Type",
      "headcount": "Headcount",
      "startDate": "Start date",
      "endDate": "End date",
      "makeForm": "Also issue an application form (generates a public /f/… URL)",
      "submit": "Convert"
    }
  },
  "campEdit": {
    "title": "Edit camp",
    "description": "Update the camp details.",
    "infoUrlLabel": "Plan page URL (optional)",
    "infoUrlNote": "Shown as an \"About this plan\" link in the top-right of the public form's first view.",
    "update": "Update",
    "errors": {
      "invalidUrl": "Enter a URL starting with http:// or https://"
    }
  },
  "quote": {
    "title": "Quotes",
    "versionPlaceholder": "Select version",
    "addItem": "Add line item",
    "importCsv": "Import CSV",
    "importPdf": "Import PDF",
    "exportCsv": "Export CSV",
    "exportFilename": "quote_v{{version}}.csv",
    "compare": "Compare quotes",
    "compareDisabledHint": "At least two quotes are required to compare",
    "createdAtLabel": "Created",
    "colCategory": "Category",
    "colTarget": "Applies to",
    "colDescription": "Description",
    "colUnitPrice": "Unit price",
    "colQuantity": "Qty",
    "colSubtotal": "Subtotal",
    "colPartner": "Partner",
    "total": "Total",
    "perPersonOverall": "Per person ({{count}} people)",
    "perPersonUnit": "/person",
    "partnerBreakdown": "Breakdown by partner",
    "headcountSimulation": "Headcount simulation",
    "currentHeadcountLabel": "Current headcount",
    "paxAdult": "Adults: {{count}}",
    "paxAdult2": "Adults (2): {{count}}",
    "paxChild": "Children: {{count}}",
    "paxInfant": "Infants: {{count}}",
    "paxOther": "Other: {{count}}",
    "paxTotalSuffix": " (total {{count}})",
    "allSharedInfo": "All costs are shared, so changing the headcount does not affect the total. Set each line item's \"Applies to\" field to enable headcount-based calculation.",
    "originalTotal": "Original total",
    "sharedCost": "Shared costs",
    "simLineAdult": "Adults x {{count}}",
    "simLineAdult2": "Adults (2) x {{count}}",
    "simLineChild": "Children x {{count}}",
    "simLineInfant": "Infants x {{count}}",
    "simLineOther": "Other x {{count}}",
    "capacityBreakdownTitle": "Items that scale with headcount",
    "capacityLine": "{{description}}: {{from}} → {{to}} ({{unit}}/unit)",
    "simulatedTotal": "Simulated total ({{count}} people)",
    "difference": "Difference",
    "perPerson": "Per person",
    "emptyItems": "No quote line items yet",
    "selfCompany": "In-house",
    "unknownPartner": "Unknown",
    "category": {
      "accommodation": "Accommodation",
      "transport": "Transport",
      "content": "Content",
      "meal": "Meals",
      "pmFee": "PM fee",
      "coachFee": "Coach fee",
      "other": "Other",
      "pm_fee": "PM fee",
      "coach_fee": "Coach fee"
    },
    "participant": {
      "common": "Shared",
      "adult": "Adult",
      "adult2": "Adult (2)",
      "child": "Child",
      "infant": "Infant",
      "other": "Other"
    },
    "status": {
      "draft": "Draft",
      "sent": "Sent",
      "approved": "Approved"
    }
  },
  "participant": {
    "missingBadge": "{{count}} missing",
    "title": "Participants",
    "add": "Add participant",
    "importCsv": "Import CSV",
    "importPdf": "Import PDF",
    "exportCsv": "Export CSV",
    "exportFilename": "participants.csv",
    "countPax": "{{count}}",
    "total": "Total",
    "funnel": "Participant funnel",
    "dropOff": "{{count}} not progressed",
    "searchPlaceholder": "Search by name or email...",
    "all": "All",
    "selectedCount": "{{count}} selected",
    "selectStatus": "Select status",
    "apply": "Apply",
    "clearSelection": "Clear selection",
    "empty": "No matching participants",
    "grandTotal": "Grand total ({{count}})",
    "basePrice": "Base price",
    "optionCount": "(+{{count}} options)",
    "status": {
      "interested": "Interested",
      "registered": "Registered",
      "paid_deposit": "Deposit paid",
      "confirmed": "Confirmed"
    },
    "payment": {
      "paid": "Paid",
      "deposit": "Deposit paid",
      "unpaid": "Unpaid"
    },
    "field": {
      "name": "Name",
      "role": "Role",
      "type": "Type",
      "age": "Age",
      "status": "Status",
      "email": "Email",
      "payment": "Payment",
      "price": "Price",
      "allergies": "Allergies",
      "passport": "Passport",
      "flight": "Arrival"
    },
    "staff": "Staff"
  },
  "expense": {
    "tabEstimates": "Estimates",
    "tabActuals": "Actuals",
    "tabVariance": "Variance",
    "csvImport": "Import CSV",
    "imageImport": "Import Image",
    "addEstimate": "Add Estimate",
    "addActual": "Add Actual",
    "total": "Total",
    "cogs": "COGS",
    "opex": "OpEx",
    "colCategory": "Category",
    "colCostType": "COGS / OpEx",
    "colDescription": "Description",
    "colAmount": "Amount",
    "colPartner": "Partner",
    "colNote": "Note",
    "colVendor": "Payee",
    "colPaidDate": "Paid Date",
    "colReceiptRef": "Receipt No.",
    "colReceipt": "Receipt",
    "colEstimate": "Estimate",
    "colActual": "Actual",
    "colDiff": "Difference",
    "noEstimates": "No estimate data",
    "noActuals": "No actual data",
    "noVariance": "No comparison data",
    "openReceipt": "Open receipt",
    "receiptOpenFailed": "Could not open the receipt. Please try again.",
    "receiptAlt": "Receipt",
    "category": {
      "accommodation": "Accommodation",
      "transport": "Transport",
      "content": "Content",
      "meal": "Meals",
      "pmFee": "PM Fee",
      "coachFee": "Coach Fee",
      "labor": "Labor",
      "other": "Other",
      "pm_fee": "PM Fee",
      "coach_fee": "Coach Fee"
    },
    "csvNoColumns": "No columns matching \"Description\" or \"Amount\" were found in the CSV header.\nSupported header examples: Description,Amount / Item,Cost / description,amount",
    "csvImportSuccess": "Imported {{count}} estimate(s)",
    "csvImportFailed": "Import failed: {{message}}",
    "csvNoImportableData": "No importable data was found.\n\nDebug info:\nHeader: {{header}}\nDescription column ({{descIdx}}): \"{{debugDesc}}\"\nAmount column ({{amtIdx}}): \"{{debugAmt}}\" → {{parsedAmt}}\n\nCondition: description is non-empty AND amount > 0",
    "colAmountKind": "Actual / cap",
    "kindUndecided": "Undecided",
    "kind": {
      "actual": "Actual",
      "cap": "Cap"
    },
    "amountKindFor": "Actual or cap for {{name}}",
    "issues": "Costs not pinned down: {{missing}} with no amount, {{cap}} still at the cap, {{undecided}} undecided",
    "reimbursementTitle": "Still to pay back to staff",
    "reimbursementRow": "{{name}}: {{amount}} ({{count}})",
    "reimbursementNoName": "No name",
    "reimbursementTotal": "Total {{amount}}",
    "reimbursementUnknown": "Waiting to hear if paid back: {{count}} · {{amount}}"
  },
  "itinerary": {
    "title": "Itinerary",
    "addDay": "Add Day",
    "importCsv": "Import CSV",
    "importPdf": "Import PDF",
    "exportCsv": "Export CSV",
    "exportFileName": "itinerary.csv",
    "aiEdit": "Edit Itinerary with AI",
    "themePlaceholder": "Theme (e.g. Osaka sightseeing)",
    "copyToNextDay": "Copy to next day",
    "addActivity": "Add Activity",
    "noActivities": "No activities for this day yet",
    "notConfigured": "No itinerary has been set up yet",
    "generateFromAiSummary": "Generate itinerary from AI summary",
    "deleteDayConfirm": "Delete Day {{day}}?",
    "deleteDayWithActivitiesConfirm": "Delete Day {{day}} (including {{count}} activities)?",
    "activityType": {
      "transport": "Transport",
      "accommodation": "Accommodation",
      "content": "Content",
      "meal": "Meal",
      "free": "Free time"
    },
    "transportSubtype": {
      "flight": "Flight",
      "bus": "Bus",
      "train": "Train",
      "taxi": "Taxi",
      "other": "Other"
    },
    "previewColumn": {
      "content": "Content",
      "type": "Type",
      "startTime": "Start time",
      "day": "Day",
      "scheduleType": "Schedule"
    },
    "lane": {
      "content": "Activities",
      "bus": "Bus",
      "transport": "Transport",
      "accommodation": "Accommodation",
      "meal": "Meals",
      "other": "Other"
    },
    "viewMode": {
      "day": "By day",
      "all": "All days",
      "grid": "Time grid"
    },
    "grid": {
      "untimed": "No time set",
      "empty": "(TBC)",
      "slotMinutes": "Interval",
      "minutesShort": "{{n}} min",
      "countSuffix": "{{n}} items",
      "coverage": "Coverage",
      "coverageHint": "Filled cells have something scheduled. Empty cells may be gaps.",
      "addHere": "Add here",
      "openDay": "Open this day in the by-day view"
    },
    "tbd": "TBC",
    "tbdHint": "This time is provisional",
    "timeUnset": "No time set",
    "timeUnsetHint": "These items have no start time. The time column will be blank in the PDF."
  },
  "applicant": {
    "title": "Applicants",
    "subtitle": "Aggregate applications from forms or manual entry, then promote approved applicants to participants.",
    "addManual": "Add manually",
    "addManualDisabledHint": "Publish an application form first",
    "filter": {
      "all": "All"
    },
    "review": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "auto_linked": "Auto-linked"
    },
    "empty": {
      "none": "No applications yet. Publish a form or add applicants manually to start collecting.",
      "noMatch": "No applications match this filter"
    },
    "goToFormsTab": "Go to Forms tab",
    "noName": "(No name)",
    "badge": {
      "manual": "Manual",
      "duplicate": "Possible duplicate"
    },
    "formLabel": "Form: {{label}}",
    "action": {
      "approve": "Approve",
      "reject": "Reject"
    },
    "viewDetails": "View details",
    "confirm": {
      "approve": "Approve this applicant and add them to the participant list?",
      "reject": "Reject this applicant?",
      "delete": "Permanently delete this application? This cannot be undone."
    },
    "error": {
      "nameRequired": "Name is required"
    },
    "manualDialog": {
      "title": "Add applicant manually",
      "description": "Record an application received by phone or in person.",
      "instanceLabel": "Record under which form",
      "instancePlaceholder": "Select a form",
      "submit": "Add"
    },
    "field": {
      "name": "Full name",
      "namePlaceholder": "Taro Yamada",
      "emailOptional": "Email (optional)",
      "phoneOptional": "Phone (optional)",
      "noteOptional": "Note (optional)",
      "notePlaceholder": "How they heard about it, application context, etc."
    }
  },
  "task": {
    "title": "Tasks",
    "add": "Add task",
    "arrangementProgress": "Arrangement progress",
    "searchPlaceholder": "Search tasks...",
    "selectedCount": "{{count}} selected",
    "bulkStatusChange": "Bulk status change",
    "clearSelection": "Clear selection",
    "selectAll": "Select all",
    "selectRow": "Select {{description}}",
    "emptyNoItinerary": "Add an itinerary to automatically generate tasks",
    "emptyNoMatch": "No tasks match your criteria",
    "status": {
      "label": "Status",
      "all": "All",
      "todo": "Not started",
      "inProgress": "Arranging",
      "review": "In review",
      "done": "Arranged"
    },
    "column": {
      "date": "Date",
      "time": "Time",
      "type": "Type",
      "description": "Description",
      "partner": "Partner",
      "arrangementStatus": "Arrangement status",
      "note": "Note",
      "day": "Day",
      "assignee": "Assignee"
    },
    "activityType": {
      "transport": "Transport",
      "accommodation": "Accommodation",
      "content": "Content",
      "meal": "Meal",
      "free": "Free time"
    },
    "unassigned": "Unassigned",
    "digestButton": "Send to Slack daily"
  },
  "login": {
    "heroLine1": "Turn time together",
    "heroHighlight": "into something unforgettable",
    "heroLine2Suffix": ".",
    "categoryRetreat": "Retreats",
    "categoryTraining": "Trainings",
    "categoryTour": "Tours",
    "aboutLine1": "The operations SaaS for teams running group trips,",
    "aboutLine2": "retreats & trainings — with AI-drafted quotes and summaries.",
    "feature1": "Margins and cost exposure on a single screen",
    "feature2": "Automated headcount via public sign-up forms",
    "feature3": "Manage multiple brands from one account",
    "sentTitle": "Check your inbox",
    "sentBody": "— we've sent you a login link.",
    "sentSpamHint": "Don't see it? Check your spam folder.",
    "useDifferentEmail": "Use a different email",
    "atsumeIdButton": "Continue with Camp ID",
    "divider": "or",
    "emailLabel": "Email address",
    "magicLinkButton": "Send magic link",
    "contactSubject": "About atsume.camp",
    "contactBody": "Your enquiry:\n\nOrganization:\nExpected number of participants:\nType of events you run (retreats / trainings / tours, etc.):\n\n----\nTo the atsume.camp team",
    "contactLink": "Contact us",
    "brochureSubject": "atsume.camp — request information",
    "brochureBody": "Information request:\n\nOrganization:\nDepartment / role:\nExpected number of participants:\nEvent types you're considering:\n\n----\nTo the atsume.camp team",
    "brochureLink": "Request info"
  },
  "publicInquiry": {
    "notFound": "We couldn't find this inquiry page. Please check the URL.",
    "validation": {
      "nameRequired": "Please enter your name.",
      "contactRequired": "Please enter either an email address or a phone number."
    },
    "eyebrow": "─ Inquiry",
    "introLine1": "We're here to help with training programs, tours, and retreats.",
    "introLine2": "Once we've reviewed your request, our team will get back to you.",
    "field": {
      "company": "Company / Organization",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "desiredKind": "What are you interested in?",
      "desiredDates": "Preferred timing",
      "headcount": "Estimated group size",
      "message": "Your message"
    },
    "placeholder": {
      "company": "Acme Inc.",
      "desiredDates": "e.g. late next month / around July 2026",
      "headcount": "e.g. 20",
      "message": "Tell us about your plans or ask us anything."
    },
    "submitting": "Sending",
    "submit": "Send"
  },
  "publicForm": {
    "notFound": "Form not found. Please check the URL.",
    "notPublished": "This form isn't open right now.",
    "closed": "Submissions are now closed.",
    "archived": "This form is no longer available.",
    "apply": "Apply",
    "entry": "Entry",
    "selectPlaceholder": "Select an option",
    "yes": "Yes",
    "submit": "Submit application",
    "submitting": "Submitting",
    "selectionNote": "Spots are limited, so applications may be reviewed before acceptance.",
    "fallbackOpenError": "We couldn't open this form.",
    "host": "Host",
    "invitationEyebrow": "─ Application",
    "aboutLink": "About",
    "preEvent": {
      "apply": "Pre-event form",
      "entry": "Pre-event form",
      "submit": "Submit",
      "invitationEyebrow": "─ Pre-event form"
    },
    "switchToEnglish": "Switch to English",
    "switchToJapanese": "Switch to Japanese"
  },
  "admin": {
    "refresh": "Refresh",
    "change": "Change",
    "forceResolveStuck": "Force-resolve {{count}} stuck",
    "sessionsTitle": "System Updates — Pipeline Sessions",
    "requestsTitle": "System Updates — Requests",
    "noSessions": "No sessions",
    "noRequests": "No requests",
    "kpi": {
      "open": "Open",
      "inProgress": "In progress",
      "activeSessions": "Active sessions",
      "stuck": "Stuck"
    },
    "col": {
      "status": "Status",
      "description": "Description",
      "proposal": "Proposal",
      "github": "GitHub",
      "updated": "Updated",
      "actions": "Actions",
      "category": "Category",
      "message": "Message",
      "user": "User",
      "datetime": "Date"
    },
    "requestStatus": {
      "open": "Open",
      "in_progress": "In progress",
      "done": "Done",
      "dismissed": "Dismissed"
    },
    "sessionStatus": {
      "clarifying": "Clarifying",
      "proposed": "Proposed",
      "approved": "Approved",
      "running": "Running",
      "success": "Success",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "category": {
      "bug": "Bug",
      "feature": "Feature",
      "improvement": "Improvement",
      "task": "Task",
      "other": "Other"
    },
    "elapsed": {
      "minutesAgo": "{{count}}m ago",
      "hoursAgo": "{{count}}h ago",
      "daysAgo": "{{count}}d ago"
    }
  },
  "formResponses": {
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "autoLinked": "Auto-registered"
    },
    "boolean": {
      "yes": "Yes",
      "no": "No"
    },
    "csv": {
      "submittedAt": "Submitted at",
      "status": "Status",
      "fileSuffix": "responses"
    },
    "confirmReject": "Reject this application. Are you sure?",
    "notFound": "Not found",
    "back": "← Back",
    "backShort": "Back",
    "downloadCsv": "Download CSV",
    "responseCount": "Responses",
    "mode": "Mode",
    "linkMode": {
      "auto": "Direct registration",
      "selection": "Selection (review required)",
      "none": "Survey",
      "preEvent": "Pre-event participant response"
    },
    "empty": "No responses yet",
    "table": {
      "submittedAt": "Submitted at",
      "status": "Status",
      "actions": "Actions"
    },
    "duplicate": "Duplicate",
    "duplicateTitle": "Another application with the same email and name exists",
    "approve": "Approve",
    "reject": "Reject",
    "dialog": {
      "title": "Approve application → Register as participant",
      "description": "This creates a new participant record with these details. You can edit it later.",
      "name": "Name",
      "email": "Email",
      "phone": "Phone (optional)",
      "status": "Status",
      "type": "Type",
      "submit": "Approve and register"
    },
    "participantStatus": {
      "interested": "Interested",
      "registered": "Registered",
      "paidDeposit": "Deposit paid",
      "confirmed": "Confirmed"
    },
    "participantType": {
      "adult": "Adult",
      "child": "Child"
    }
  },
  "formInstances": {
    "status": {
      "draft": "Draft",
      "published": "Published",
      "closed": "Closed"
    },
    "error": {
      "selectCamp": "Please select a camp to link.",
      "invalidEmail": "Invalid email format: {{email}}",
      "invalidSlug": "Slug may contain only lowercase letters, numbers, and hyphens, and must start and end with an alphanumeric character.",
      "missingLinkageFields": "This mode requires the template to include the {{fields}} field(s). Edit the template or choose the \"No linkage\" mode.",
      "fieldJoiner": " and "
    },
    "confirm": {
      "delete": "Delete this public URL? Its responses will also be deleted."
    },
    "templateNotFound": "Template not found",
    "backToList": "← Back to list",
    "backToEdit": "Back to edit",
    "publishDistribute": "Publish & distribute",
    "subtitle": "Issue a public URL linked to a camp. Responses can be reviewed in the admin console.",
    "createHeading": "Issue a new public URL",
    "linkedCamp": "Linked camp",
    "selectCampPlaceholder": "Select a camp...",
    "noCamps": "No camps available. Please create a camp first.",
    "slugLabel": "URL slug (optional)",
    "slugHelpPrefix": "The public URL will be",
    "slugHelpSuffix": "",
    "linkModeLabel": "Application handling mode",
    "notifyLabel": "Notification emails (sent on response, optional)",
    "notifyHelp": "Separate multiple addresses with commas or spaces. Leave blank for no notifications.",
    "createButton": "Issue public URL",
    "publishedHeading": "Issued URLs ({{count}})",
    "noneIssued": "None issued yet",
    "badge": {
      "auto": "Direct register",
      "selection": "Selection",
      "none": "Survey",
      "preEvent": "Participant pre-event"
    },
    "notifyCount": "{{count}} notifications",
    "aria": {
      "viewResponses": "View responses",
      "copyUrl": "Copy URL",
      "preview": "Preview",
      "settings": "Settings"
    },
    "copied": "Copied"
  },
  "campOverview": {
    "paymentType": {
      "deposit": "Deposit payment",
      "interim": "Interim payment",
      "final": "Final payment"
    },
    "noteType": {
      "meetingNote": "Meeting note",
      "decision": "Decision",
      "todo": "To-do",
      "default": "Note"
    },
    "partnerType": {
      "travelAgency": "Travel arrangements",
      "contentProvider": "Content",
      "coach": "Coach"
    },
    "tbd": "TBD",
    "dueInDays": "Due: {{date}} (in {{count}} days)",
    "followUpUnconfirmed": "Follow up with {{count}} unconfirmed participants",
    "changeNotesCount": "This camp has {{count}} change notes",
    "changeNotesLatest": "Latest: {{content}}",
    "changeNotesHint": "Change history for pricing and terms is available under Revenue → Payments.",
    "overallProgress": "Overall progress",
    "untilDeparture": "Until departure",
    "daysValue": "{{count}} days",
    "today": "Today",
    "schedule": "Schedule",
    "nightsDays": "{{nights}} nights / {{days}} days",
    "participants": "Participants",
    "paxCount": "{{count}} people",
    "paxBreakdown": "Adults {{adult}} / Children {{child}}",
    "budget": "Budget",
    "budgetUsed": "{{percent}}% used",
    "nextActions": "Next actions",
    "noActions": "No actions at this time",
    "collapse": "Collapse",
    "showMore": "Show {{count}} more",
    "partners": "Partners",
    "role": "Role",
    "contact": "Contact",
    "aiSummary": "AI summary",
    "updatedAt": "Updated: {{date}}",
    "generateFromSummary": "Generate itinerary from AI summary",
    "aiSummaryRequired": "An AI summary is required",
    "generateItineraryFromSummary": "Generate itinerary from summary",
    "aiSummaryEmpty": "No AI summary has been generated yet. It updates automatically as data accumulates.",
    "recentActivity": "Recent activity",
    "activity": {
      "taskDone": "Completed task \"{{title}}\"",
      "taskStarted": "Started task \"{{title}}\"",
      "taskCreated": "Created task \"{{title}}\"",
      "noteAdded": "Added {{type}} \"{{title}}\"",
      "paymentConfirmed": "{{type}} ¥{{amount}} payment confirmed"
    }
  },
  "campForms": {
    "errors": {
      "selectTemplate": "Please select a template",
      "missingFields": "To issue in this mode, the template needs the {{fields}} field(s).",
      "fieldsConjunction": " and ",
      "invalidEmail": "Invalid email format: {{email}}",
      "invalidSlug": "Slug must use only lowercase letters, numbers, and hyphens, and start and end with an alphanumeric character"
    },
    "newTemplateName": "{{campName}} application form",
    "confirmDelete": "Delete this public URL? Its responses will also be deleted.",
    "title": "Application Forms",
    "subtitle": "Issue public forms for this project, such as applications, participant info, and surveys.",
    "issueNewUrl": "Issue a new public URL",
    "newTemplate": "New template",
    "noTemplates": "No form templates yet.",
    "noTemplatesHint": "Use the \"New template\" button to create a form for this project.",
    "templateLabel": "Template",
    "templatePlaceholder": "Select a template...",
    "editTemplate": "Edit template",
    "slugLabel": "URL slug (optional)",
    "slugHelpPrefix": "The public URL will be",
    "slugHelpSuffix": ".",
    "linkModeLabel": "Application handling mode",
    "notifyLabel": "Notification email (sent on response, optional)",
    "notifyHelp": "Separate multiple addresses with commas or spaces. Leave blank for no notifications.",
    "issueUrlButton": "Issue public URL",
    "issuedUrls": "Issued URLs ({{count}})",
    "noInstances": "No forms have been issued for this project yet",
    "mode": {
      "auto": "Direct registration",
      "selection": "Selection",
      "none": "Survey",
      "preEvent": "Pre-event participant response"
    },
    "notifyCount": "{{count}} notification(s)",
    "viewResponses": "View responses",
    "copyUrl": "Copy URL",
    "showQr": "Show QR code",
    "preview": "Preview",
    "settings": "Settings",
    "copied": "Copied"
  },
  "itineraryGen": {
    "title": "AI-Generated Itinerary",
    "description": "Review and edit the itinerary extracted from the AI summary before applying it to the itinerary tab.",
    "errorEmptySummary": "The AI summary is empty. Please enter an overview first.",
    "errorNoExtract": "The AI could not extract an itinerary. Make the summary more specific and try again.",
    "errorGenerateFailed": "Generation failed",
    "existingDaysPrefix": "You already have",
    "existingDaysCount": "{{count}} day(s)",
    "existingDaysSuffix": "of itinerary",
    "modeAppend": "Append",
    "modeReplace": "Replace (delete existing)",
    "editPromptToggle": "Edit prompt and regenerate",
    "retry": "Try again",
    "overrideLabel": "Additional instructions for the AI (e.g. keep each day's theme more concise / split meals into 3)",
    "overridePlaceholder": "Enter any additional instructions...",
    "regenerate": "Regenerate",
    "generating": "Generating... usually 5-10 seconds",
    "themePlaceholder": "Theme",
    "noActivities": "No activities",
    "confirmReplace": "The existing {{count}}-day itinerary will be permanently deleted. Are you sure?",
    "countSummary": "{{days}} day(s) · {{count}} activity(ies)",
    "applyReplaceConfirm": "Replace with {{count}} activity(ies)",
    "applyReplace": "Replace with {{count}} →",
    "applyAppend": "Append {{count}} →",
    "editActivity": "Edit",
    "removeActivity": "Remove",
    "fieldTime": "Time",
    "fieldType": "Type",
    "fieldDescription": "Description",
    "fieldNote": "Note (optional)"
  },
  "partnersSection": {
    "title": "Partners",
    "addPartner": "Add partner",
    "partnerType": {
      "travelAgency": "Travel agency",
      "contentProvider": "Content provider",
      "coach": "Coach"
    },
    "taskStatus": {
      "todo": "To do",
      "inProgress": "In progress",
      "review": "Review",
      "done": "Done"
    },
    "responseStatus": {
      "noTasks": "No tasks",
      "done": "Completed",
      "inProgress": "In progress",
      "notStarted": "Not started"
    },
    "staleTitle": "{{count}} days since a task was last added or updated. Shown for partners with no activity for over 7 days while still incomplete.",
    "staleLabel": "(no activity for {{count}} days)",
    "contactPerson": "Contact",
    "email": {
      "subject": "[atsume.camp] Confirmation request",
      "body": "Dear {{recipient}},\n\nThank you for your continued support.\n{{topic}}there are items we would like to confirm with you.\n\n■ Items to confirm\n- \n\n■ Deadline\n- \n\nWe apologize for the trouble and appreciate your confirmation.\n\n---\natsume.camp",
      "topicWithRole": "Regarding {{role}}, ",
      "topicDefault": "Regarding this project, ",
      "compose": "Compose email"
    },
    "assignedCategoriesLabel": "Assigned categories",
    "taskProgress": "Task progress",
    "taskCompletion": "{{completed}}/{{total}} done",
    "noTasksAssigned": "No tasks assigned",
    "emptyState": "No partners assigned yet",
    "dialog": {
      "title": "Assign partner",
      "partnerLabel": "Partner",
      "partnerPlaceholder": "Select a partner...",
      "roleLabel": "Role description",
      "rolePlaceholder": "e.g. In charge of accommodation arrangements",
      "categoriesLabel": "Assigned categories (comma-separated)",
      "categoriesPlaceholder": "e.g. Accommodation, Transportation",
      "assign": "Assign",
      "regionLabel": "Filter by region",
      "regionPlaceholder": "Region",
      "allRegions": "All regions",
      "noPartnersInRegion": "No partners registered in this region yet."
    },
    "coachInvoice": {
      "none": "Not contacted",
      "sent": "Link sent",
      "submitted": "Submitted",
      "approved": "Approved",
      "updatedAt": "Updated: {{date}}"
    }
  },
  "expenseEstimate": {
    "titleEdit": "Edit expense estimate",
    "titleAdd": "Add expense estimate",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select a category",
    "indirectLabel": "Treat as overhead (in-house PM fee / operating indirect cost)",
    "segmentLabel": "Segment",
    "segmentCommon": "Common cost (allocated to all)",
    "segmentAdult": "Adults only",
    "segmentAdult2": "Adults (2) only",
    "segmentChild": "Children only",
    "segmentInfant": "Infants only",
    "segmentOther": "Other only",
    "segmentHint": "Specifies which segment this cost is tied to when auto-calculating tour pricing.",
    "descriptionPlaceholder": "e.g. Hotel stay (30 adults x 9 nights)",
    "amountLabel": "Amount (JPY)",
    "partnerPlaceholder": "Select a partner",
    "partnerNone": "None",
    "payerSectionLabel": "Payer / self-borne amount",
    "payerLabel": "Payer (advance)",
    "payerSelf": "Paid in-house",
    "selfBurdenLabel": "Self-borne amount (JPY)",
    "advanceHint": "The advanced amount {{amount}} is borne by the payer. Only the self-borne amount is recorded as a P/L expense.",
    "submitUpdate": "Update",
    "submitAdd": "Add",
    "errorCategoryRequired": "Please select a category",
    "errorDescriptionRequired": "Description is required",
    "errorAmountMin": "Enter a number of 0 or greater"
  },
  "activityDialog": {
    "typeRequired": "Please select a type",
    "descriptionRequired": "Description is required",
    "editTitle": "Edit Activity",
    "addTitle": "Add Activity",
    "startTime": "Start Time",
    "endTime": "End Time",
    "type": "Type",
    "typePlaceholder": "Select a type",
    "transportMeans": "Transport Mode",
    "transportMeansPlaceholder": "Select a transport mode",
    "arrivalDate": "Arrival Date",
    "description": "Description",
    "descriptionPlaceholder": "e.g. Arrive at Narita Airport, transfer to hotel by charter bus",
    "note": "Note",
    "notePlaceholder": "Additional details",
    "partner": "Partner",
    "partnerPlaceholder": "Select a partner",
    "partnerNone": "None",
    "update": "Update",
    "add": "Add",
    "createTaskConfirm": "💡 Create a \"{{suggestion}}\" task?",
    "taskSuggestion": {
      "accommodation": "Confirm hotel reservation",
      "transport": "Confirm transport arrangements",
      "content": "Confirm content arrangements",
      "meal": "Confirm meal arrangements"
    },
    "timeTbd": "Provisional time",
    "timeTbdHint": "Use this when only AM/PM is decided. The PDF shows \"(TBC)\" next to the time.",
    "quickAm": "AM 9:00-12:00",
    "quickPm": "PM 13:00-18:00"
  },
  "participantDialog": {
    "editTitle": "Edit Participant",
    "addTitle": "Add Participant",
    "field": {
      "type": "Type",
      "age": "Age",
      "basePrice": "Price (per person, JPY)",
      "phone": "Phone",
      "passportNumber": "Passport Number",
      "roomAssignment": "Room Assignment",
      "allergies": "Allergies",
      "givenNameRoman": "Given name (roman)",
      "familyNameRoman": "Family name (roman)",
      "dateOfBirth": "Date of birth",
      "gender": "Gender",
      "nationality": "Nationality",
      "passportExpiry": "Passport expiry",
      "arrivalFlight": "Arrival flight",
      "arrivalAt": "Arrival time",
      "arrivalAirport": "Arrival airport",
      "departureFlight": "Departure flight",
      "departureAt": "Departure time",
      "departureAirport": "Departure airport",
      "note": "Note",
      "visaDocStatus": "Visa paperwork"
    },
    "total": "Total",
    "add": "Add",
    "update": "Update",
    "options": {
      "label": "Options (optional)",
      "add": "Add Option"
    },
    "placeholder": {
      "role": "e.g. Head Coach",
      "basePrice": "e.g. 300000",
      "optionLabel": "e.g. Airport Transfer",
      "optionAmount": "Amount",
      "allergies": "e.g. Shellfish, Peanuts",
      "givenNameRoman": "Bimal",
      "familyNameRoman": "Wagle",
      "nationality": "Australia",
      "flight": "JL772",
      "airport": "KIX",
      "note": "Replaced whom, cancellation reason, etc."
    },
    "validation": {
      "nameRequired": "Name is required",
      "emailInvalid": "Please enter a valid email address"
    },
    "section": {
      "travel": "Travel details",
      "travelHint": "Enter exactly as printed in the passport. Used for insurance and ticketing.",
      "flight": "Flights"
    },
    "gender": {
      "unset": "Not set",
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "visa": {
      "exempt": "This nationality is visa-exempt for short stays (for reference — confirm with the agency)",
      "conditional": "Conditionally visa-exempt. Check with the agency whether pre-registration is needed",
      "required": "A visa may be required. Check with the agency early"
    },
    "visaDoc": {
      "unset": "Not recorded",
      "not_started": "Not started",
      "letter_issued": "Invitation letter issued",
      "applied": "Applied",
      "granted": "Granted",
      "not_needed": "Confirmed not needed"
    }
  },
  "revenueV2": {
    "title": "Revenue",
    "tabPl": "P&L Overview",
    "tabRevenue": "Revenue",
    "tabCogs": "COGS",
    "tabOpex": "Operating Expenses",
    "tabPayments": "Payments",
    "metricRevenue": "Revenue",
    "metricCogs": "COGS",
    "metricGrossProfit": "Gross Profit",
    "metricOpex": "Operating Expenses",
    "metricOperatingProfit": "Operating Profit",
    "unitEconomicsTitle": "Per-Person Unit Economics",
    "paxBreakdown": "{{total}} pax total (Adult {{adult}} / Adult 2 {{adult2}} / Child {{child}} / Infant {{infant}} / Other {{other}})",
    "unitPriceLabel": "Unit Price (Revenue ÷ Pax)",
    "perPaxCogs": "COGS per Pax",
    "perPaxGrossProfit": "Gross Profit per Pax",
    "plSummaryTitle": "P&L Summary (Own-Burden Basis)",
    "advanceNote": "Note: Partner-advanced total {{amount}} is excluded from P&L. COGS and expenses are tallied on own-burden amounts only.",
    "paymentStatusTitle": "Payment Status",
    "paidOverDue": "Paid / Total Billed",
    "lossBadge": "Loss",
    "actualLabel": "Actual",
    "displaySettings": "Display settings",
    "exportPdf": "Export PDF",
    "includeRelated": "Include related tours (combines the P&L overview and the PDF)",
    "showAud": "Show A$ alongside",
    "combinedNote": "The P&L overview and PDF combine {{names}}. The revenue / COGS / OpEx / payment tabs still edit this tour only.",
    "byCampTitle": "By tour",
    "byCampName": "Tour",
    "byCampPax": "Pax",
    "byCampTotal": "Total"
  },
  "cogsPricing": {
    "noPaxTitle": "⚠ Head-count not set",
    "noPaxDescription": "Set the number of participants (adults, children, infants) on the Overview tab and pricing will be calculated automatically from cost.",
    "title": "Cost-based automatic pricing",
    "noCogsTitle": "No cost entered yet",
    "noCogsDescription": "Enter hotel, transport and other costs on the Cost Management tab to see per-segment pricing here automatically.",
    "colSegment": "Segment",
    "colPax": "Pax",
    "colUnitCost": "Unit cost",
    "colUnitPrice": "Unit price",
    "colSubtotal": "Subtotal",
    "individualBadge": "Custom",
    "paxCount": "{{count}} pax",
    "totalRevenueWithMargin": "Total revenue (effective margin {{rate}}%)",
    "unallocatedWarning": "{{segments}} has segment-specific cost, but with 0 pax it is not reflected in pricing.",
    "profitSettingGlobal": "Profit setting (global)",
    "marginRate": "Margin rate",
    "profitAmount": "Profit amount",
    "marginRateHint": "% — price = cost ÷ (1 − margin rate)",
    "profitAmountUnit": "JPY (profit for the whole tour)",
    "allocCostProportional": "Allocate proportional to cost",
    "allocPerPax": "Allocate evenly per pax",
    "perSegmentToggle": "Customize per segment (optional)",
    "overrideCount": "{{count}}",
    "overrideGlobal": "Follow global",
    "overrideMarginRate": "Margin rate (%)",
    "overrideProfitAmount": "Profit amount (JPY/pax)",
    "savedBadge": "Saved",
    "saveAndApply": "Save and apply to revenue"
  },
  "plView": {
    "tabPl": "P&L",
    "tabRevenue": "Revenue",
    "tabPayments": "Payments",
    "taxChip": "Tax undecided: {{count}}",
    "flowLabel": "Money flow for this tour",
    "flowVia": "Via partner ({{name}})",
    "flowViaPick": "Via partner",
    "flowDirect": "Direct only",
    "flowPartner": "Settling partner",
    "flowPartnerPick": "Choose a partner",
    "flowViaHint": "Lines the partner pays wait for its statement; the partner's settlement is our income",
    "flowDirectHint": "The client pays us directly and we pay suppliers",
    "kpiLandingCost": "Forecast cost",
    "kpiLandingCostSub": "Actual so far {{actual}}",
    "kpiVariance": "Budget variance (forecast)",
    "overBudget": "Over budget",
    "kpiVarianceSub": "Budgeted cost {{budget}}",
    "kpiReceived": "Received",
    "kpiReceivedSub": "{{rate}}% of billed ({{billed}})",
    "kpiReceivedNone": "Money received in our account",
    "kpiCash": "Net cash",
    "kpiCashSub": "Received − paid by us",
    "budgetTitle": "Budget vs actual",
    "importCsv": "Import CSV",
    "importImage": "Import image",
    "addActual": "Add expense",
    "addBudgetLine": "Add budget line",
    "taxBanner": "{{count}} budget lines have no tax mode yet, so the variance is indicative. Align them with “Tax” at the top.",
    "hideZero": "Hide lines with ¥0 budget and actual",
    "colLine": "Line",
    "colStatus": "Status",
    "colBudget": "Budget",
    "colActual": "Actual",
    "colLanding": "Forecast",
    "colVariance": "Variance (budget − forecast)",
    "colItem": "Item",
    "colPerPax": "Per person (forecast)",
    "secCogs": "Cost of sales",
    "secOpex": "SG&A",
    "groupPartner": "Paid by {{name}}",
    "groupPartnerHint": "Paid by the partner out of the client's money; the rest is settled to us",
    "groupCompany": "Paid by us",
    "groupCompanyHint": "We pay suppliers, coaches and people who advanced money",
    "boxCollected": "Client → {{name}}",
    "boxPartnerCost": "Partner's actual cost (statement)",
    "boxSettlement": "{{name}} → us",
    "notEntered": "Not entered",
    "awaitingStatement": "Awaiting statement",
    "enterInPayments": "Enter on Payments →",
    "enterPerLine": "Open a line to enter the statement amount",
    "noOpex": "No SG&A for this tour yet.",
    "total": "Total",
    "landingNote": "Forecast = actual for paid/settled lines, otherwise the larger of budget and actual. Only over-budget lines are red.",
    "taxQ": "Tax?",
    "provisional": "{{count}} unconfirmed",
    "provisionalOne": "Unconfirmed",
    "status": {
      "unbilled": "Not billed",
      "billed": "Billed",
      "paid": "Paid",
      "awaiting_statement": "Awaiting statement",
      "settled": "Settled"
    },
    "paidBy": "Paid by",
    "paidByCompany": "Us",
    "paidByPartner": "{{name}} (settled)",
    "editLine": "Edit line",
    "actualsTitle": "{{count}} expenses",
    "addStatementLine": "Enter statement amount",
    "noActuals": "None yet. Add the invoice with “Add expense”.",
    "noActualsPartner": "None yet. When the partner's statement arrives, enter this line's amount.",
    "advancedBy": "Advanced by {{name}}",
    "edit": "Edit",
    "unassignedTitle": "Unassigned spend",
    "unassignedSub": "{{count}} items · assign lines on the Settlement tab →",
    "needsAssign": "Assign",
    "unassignedHint": "Choose the budget line for each item. Reimbursement approval is on the Settlement tab.",
    "assignTo": "Choose a line",
    "combinedBudgetNote": "Combined view compares per-tour budgets. Open a single tour for line-level budget vs actual.",
    "statementTitle": "Income statement",
    "rowRevenue": "Revenue",
    "rowCogs": "Cost of sales",
    "rowGross": "Gross profit",
    "rowOpex": "SG&A",
    "rowOperating": "Operating profit",
    "cashTitle": "Cash (as of now, this tour)",
    "cashReceived": "Received by us",
    "cashPaid": "Paid by us",
    "cashNet": "Net cash",
    "cashNotYet": "Not yet received or settled",
    "cashNotYetHint": "Gross profit (forecast) − net cash. Becomes 0 when everything is settled"
  },
  "expenseActual": {
    "estimateLabel": "Budget line",
    "estimateNone": "Unassigned",
    "editTitle": "Edit Actual Expense",
    "addTitle": "Add Actual Expense",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select a category",
    "categoryRequired": "Please select a category",
    "descriptionRequired": "Description is required",
    "amountMin": "Enter a number of 0 or greater",
    "isIndirectLabel": "Treat as expense (in-house PM fees / operating overhead)",
    "descriptionPlaceholder": "e.g. Shinagawa Prince Hotel accommodation",
    "partnerPlaceholder": "Select a partner",
    "partnerNone": "None",
    "amountYenLabel": "Amount (JPY)",
    "payerSelfBurdenTitle": "Payer / In-House Share",
    "payerLabel": "Payer (advance)",
    "payerSelf": "Paid by us",
    "selfBurdenAmountLabel": "In-house share (JPY)",
    "advanceNote": "The advanced amount of ¥{{amount}} is borne by the payer. Only the in-house share is recorded in the P&L.",
    "receiptImageLabel": "Receipt Image",
    "noteLabel": "Note",
    "update": "Update",
    "add": "Add"
  },
  "quoteItem": {
    "editTitle": "Edit quote item",
    "addTitle": "Add quote item",
    "categoryLabel": "Category",
    "categoryPlaceholder": "Select category",
    "categoryRequired": "Please select a category",
    "participantLabel": "Participant type",
    "participantPlaceholder": "Select participant type",
    "descriptionRequired": "Description is required",
    "descriptionPlaceholder": "e.g. Shinagawa Prince Hotel, 20 twin rooms x 7 nights",
    "unitPriceYen": "Unit price (JPY)",
    "subtotalYen": "Subtotal (JPY)",
    "subtotalMin": "Please enter a value of 0 or greater",
    "partnerLabel": "Partner",
    "partnerPlaceholder": "Select partner",
    "partnerNone": "None",
    "capacityUnitLabel": "Capacity per unit (optional)",
    "capacityUnitPlaceholder": "e.g. 45 for a bus, 4 for a room",
    "capacityUnitHelp": "For lines like buses or rooms where the needed count changes with headcount. When set, the headcount simulation recalculates how many units are needed.",
    "update": "Update",
    "add": "Add"
  },
  "campDetail": {
    "tabOverview": "Overview",
    "tabNotes": "Notes",
    "tabRooming": "Rooming",
    "tabDocuments": "Documents",
    "sectionNav": "Sections",
    "moreSections": "More",
    "allSections": "All sections",
    "notFound": "Camp not found",
    "idLabel": "ID: {{id}}",
    "aiAssistant": "AI Assistant",
    "progress": "Progress",
    "untilDeparture": "Until departure",
    "daysCount": "{{count}} days",
    "departsToday": "Departs today",
    "departed": "Departed"
  },
  "paymentSection": {
    "title": "Payments",
    "exportCsv": "Export CSV",
    "csvFileName": "payment-schedule.csv",
    "addMilestone": "Add milestone",
    "overdueAlert": "{{count}} payment(s) past due",
    "unpaidTotal": "Unpaid total",
    "paymentManagement": "Payment management",
    "totalAmount": "Total amount",
    "paidAmount": "Paid",
    "remaining": "Remaining",
    "overdueCount": "{{count}} overdue",
    "paymentProgress": "Payment progress",
    "timeline": "Payment timeline",
    "dueDateTbd": "TBD",
    "paidDate": "Paid on",
    "markPaid": "Mark as paid",
    "empty": "No payment milestones set",
    "scheduleTitle": "Expected payments to us",
    "addSchedule": "Add expected payment",
    "scheduleEmpty": "No expected payments yet. Use \"+ Add expected payment\" to register payments from the client or a partner.",
    "rowHint": "Click a row to edit it.",
    "colSource": "From",
    "colLabel": "Description",
    "colDue": "Due",
    "colPlanned": "Expected",
    "colReceived": "Received",
    "colStatus": "Status",
    "notEntered": "Not entered",
    "statementPending": "Awaiting statement",
    "sourceClient": "Client",
    "sourcePartner": "Partner",
    "clientFallback": "Client",
    "partnerFallback": "Partner",
    "summaryLine": "Expected {{total}} · Received {{paid}} · Remaining {{remaining}}",
    "partnerCard": {
      "title": "Money held by the partner",
      "notOurAccount": "Does not reach our account",
      "colFlow": "Client → Partner",
      "colCollected": "Collected",
      "colPartnerCost": "Partner's costs",
      "colSettlement": "Settlement to us",
      "enter": "Enter",
      "enterSettlement": "Enter settlement",
      "collectedLabel": "Amount the client paid the partner",
      "save": "Save",
      "cancel": "Cancel",
      "settlementLabel": "Settlement from travel fees",
      "hint": "Partner's costs add up from the statement amounts entered per budget line on the P&L tab. The settlement goes into the \"{{partner}}\" row of the expected payments above."
    },
    "type": {
      "deposit": "Deposit",
      "interim": "Interim payment",
      "final": "Final payment"
    },
    "status": {
      "paid": "Paid",
      "pending": "Unpaid",
      "overdue": "Overdue"
    }
  },
  "expenseCsvPreview": {
    "title": "CSV Import Preview",
    "noValidData": "No valid data found. An amount column is required.",
    "colVendor": "Vendor",
    "colDate": "Date",
    "importSummary": "Importing {{included}}/{{total}}",
    "totalAmount": "Total: ¥{{amount}}",
    "registering": "Registering...",
    "registerCount": "Register {{count}}",
    "importFailed": "Import failed",
    "categoryAccommodation": "Accommodation",
    "categoryTransport": "Transport",
    "categoryContent": "Content",
    "categoryMeal": "Meal",
    "categoryPmFee": "PM Fee",
    "categoryCoachFee": "Coach Fee",
    "categoryLabor": "Labor",
    "categoryOther": "Other"
  },
  "partnersPage": {
    "title": "Partners",
    "addPartner": "Add partner",
    "searchPlaceholder": "Search by partner name...",
    "typeFilterPlaceholder": "Type",
    "allTypes": "All types",
    "typeTravelAgency": "Travel agency",
    "typeContentProvider": "Content provider",
    "typeCoach": "Coach",
    "columnCompanyName": "Company",
    "columnType": "Type",
    "columnContactPerson": "Contact",
    "columnPhone": "Phone",
    "columnEmail": "Email",
    "columnServices": "Services",
    "columnRegions": "Regions",
    "columnActions": "Actions",
    "emptyState": "No matching partners",
    "partnerCount": "{{count}} partners",
    "regionFilterPlaceholder": "Region",
    "allRegions": "All regions"
  },
  "taskDialog": {
    "activityType": {
      "transport": "Transport",
      "accommodation": "Accommodation",
      "content": "Content",
      "meal": "Meal",
      "free": "Free time",
      "other": "Other"
    },
    "validation": {
      "titleRequired": "Content is required"
    },
    "title": {
      "edit": "Edit task",
      "add": "Add task"
    },
    "field": {
      "date": "Date",
      "time": "Time",
      "type": "Type",
      "content": "Content",
      "partner": "Partner",
      "note": "Note"
    },
    "placeholder": {
      "title": "e.g. New Otani Osaka check-in",
      "partner": "Select a partner",
      "note": "Additional details"
    },
    "partner": {
      "none": "None"
    },
    "submit": {
      "update": "Update",
      "add": "Add"
    }
  },
  "importPreview": {
    "entityParticipants": "Participants",
    "entityItinerary": "Itinerary",
    "entityQuoteItems": "Quote Items",
    "entityPayments": "Payments",
    "title": "Import {{entity}} from CSV",
    "fileReadError": "File read error: {{message}}",
    "selectCsvFile": "Please select a CSV file",
    "dropZonePrompt": "Drop a CSV file, or",
    "selectFile": "Select a file",
    "dropZoneHint": "Import an exported CSV as is (the _id column determines updates)",
    "updateBadge": "{{count}} to update",
    "insertBadge": "{{count}} new",
    "errorsHeading": "Errors ({{count}})",
    "moreItems": "...and {{count}} more",
    "columnType": "Type",
    "insertLabel": "New",
    "updateLabel": "Update",
    "selectAnotherFile": "Select another file",
    "importButton": "Import ({{count}})"
  },
  "formFieldEditor": {
    "fieldType": {
      "text": "Short text",
      "textarea": "Long text",
      "number": "Number",
      "email": "Email",
      "tel": "Phone number",
      "date": "Date",
      "select": "Dropdown",
      "checkbox": "Checkbox",
      "section": "Section (heading)"
    },
    "label": "Label",
    "labelPlaceholder": "e.g. Full name",
    "type": "Type",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "placeholderLabel": "Placeholder (optional)",
    "helpTextLabel": "Help text (optional)",
    "optionsLabel": "Options (one per line)",
    "optionsPlaceholder": "Option A\nOption B\nOption C",
    "required": "Required field"
  },
  "pdfImport": {
    "target": {
      "itinerary": "Itinerary",
      "quoteItems": "Cost Estimate",
      "participants": "Participants"
    },
    "title": "Import {{target}} from PDF",
    "error": {
      "notPdf": "Please select a PDF file",
      "fileTooLarge": "File size must be 4MB or less (due to base64 conversion)",
      "emptyResult": "The AI analysis returned no results. Please try a different PDF.",
      "parseFailed": "AI analysis error: {{message}}"
    },
    "analyzing": "Analyzing with AI...",
    "analyzingDescription": "Reading and structuring the PDF content",
    "dropZone": "Drop a PDF file, or",
    "selectFile": "Select a file",
    "supportedDocuments": "Supports PDFs such as travel agency quotes, booking confirmations, and participant lists",
    "extractedCount": "{{count}} extracted",
    "moreRows": "...and {{count}} more",
    "selectAnotherFile": "Select another file",
    "importAction": "Import ({{count}})"
  },
  "expenseOcr": {
    "title": "Add Expense from Receipt/Invoice",
    "uploadPrompt": "Upload an image or PDF of a receipt or invoice",
    "selectFile": "Select File",
    "supportedFormats": "Supported formats: JPG, PNG, PDF",
    "analyzing": "AI is analyzing the image...",
    "category": "Category",
    "date": "Date",
    "vendor": "Vendor",
    "register": "Add Expense",
    "errorExtractFailed": "Could not extract data. Please enter it manually.",
    "errorParseFailed": "Failed to analyze the image. Please enter it manually.",
    "errorAmountRequired": "Please enter an amount",
    "categoryAccommodation": "Accommodation",
    "categoryTransport": "Transport",
    "categoryContent": "Content",
    "categoryMeal": "Meals",
    "categoryPmFee": "PM Fee",
    "categoryCoachFee": "Coach Fee",
    "categoryLabor": "Labor",
    "categoryOther": "Other"
  },
  "revenue": {
    "title": "Revenue management",
    "tabPl": "P&L overview",
    "tabSales": "Sales",
    "tabPayments": "Payments",
    "tabExpenses": "Expenses",
    "revenueBudget": "Revenue (budget)",
    "expenseEstimate": "Estimated expenses",
    "expenseActual": "Actual expenses",
    "grossProfitEstimateBase": "Gross profit (estimate basis)",
    "plSummary": "P&L summary",
    "grossProfitEstimate": "Gross profit (estimated)",
    "grossProfitActual": "Gross profit (actual)",
    "paymentStatus": "Payment status",
    "paidOverDue": "Paid / Total invoiced"
  },
  "formBuilder": {
    "templateNotFound": "Template not found",
    "backToFormList": "Back to form list",
    "back": "Back",
    "saving": "Saving...",
    "publishDistribute": "Publish & distribute",
    "linkagePrereqPrefix": "To publish with participant linkage (direct registration / selection), the ",
    "fieldJoiner": " and ",
    "linkagePrereqSuffix": " field(s) are required. Not needed in \"Survey (no linkage)\" mode.",
    "formName": "Form name",
    "formNamePlaceholder": "e.g. Participant information form",
    "descriptionOptional": "Description (optional)",
    "descriptionPlaceholder": "Guidance text for applicants...",
    "questions": "Questions ({{count}})",
    "addField": "Add field",
    "noQuestionsYet": "No questions yet",
    "addFirstField": "Add your first field"
  },
  "quickTour": {
    "welcomeTitle": "Welcome to atsume.camp",
    "welcomeBody": "Plan group trips and retreats, build quotes, coordinate bookings, and settle costs — all in one place. Let's take a quick look at the essentials.",
    "dashboardTitle": "Dashboard",
    "dashboardBody": "See all your active projects and their progress at a glance. Open any project here to start working.",
    "campsTitle": "Projects & Project Details",
    "campsBody": "Manage each project's itinerary, participants, partner bookings, and tasks across simple tabs — complete with a countdown to departure and live progress.",
    "revenueTitle": "Revenue — pricing calculated automatically from costs",
    "revenueBody": "Enter costs like hotels and flights under Costs, tagged by category (shared, adult, child, infant), and Sales calculates tour pricing per category automatically. Set your margin or markup, and attach receipt images in Expenses.",
    "formsTitle": "Forms",
    "formsBody": "Publish a shareable form to collect participant details. Responses flow straight in as applicants and participants.",
    "aiTitle": "AI Assistant",
    "aiBody": "Open any project to use the AI assistant on the right. Ask it to refine your itinerary or talk through your quote.",
    "skip": "Skip",
    "close": "Close",
    "back": "Back",
    "start": "Get started",
    "next": "Next ({{current}}/{{total}})"
  },
  "partnerDialog": {
    "titleEdit": "Edit Partner",
    "titleAdd": "Add Partner",
    "companyName": "Company Name",
    "type": "Type",
    "contactPerson": "Contact Person",
    "email": "Email",
    "phone": "Phone",
    "services": "Services (comma-separated)",
    "servicesPlaceholder": "e.g. Soccer, Rugby, Tea Ceremony",
    "regions": "Service Regions (comma-separated)",
    "regionsPlaceholder": "e.g. Tokyo, Osaka, Hokkaido",
    "update": "Update",
    "add": "Add",
    "errorNameRequired": "Company name is required",
    "errorEmailInvalid": "Please enter a valid email address"
  },
  "noteDialog": {
    "editTitle": "Edit Note",
    "addTitle": "Add Note",
    "typeLabel": "Type",
    "typePlaceholder": "Select type",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Kickoff meeting",
    "contentLabel": "Content",
    "contentPlaceholder": "Enter note content",
    "update": "Update",
    "add": "Add",
    "noteType": {
      "payment": "Payment Note"
    },
    "errors": {
      "typeRequired": "Please select a type",
      "titleRequired": "Title is required"
    }
  },
  "notesSection": {
    "title": "Notes",
    "aiSummary": "AI Summary",
    "addNote": "Add Note",
    "empty": "No notes yet",
    "shareEmail": "Share via email",
    "shareEmailSubject": "[atsume.camp] {{title}}",
    "shareEmailBody": "{{title}}\n\n{{content}}\n\n---\nSent from atsume.camp",
    "summarizePrompt": "Please summarize the following meeting notes concisely. List decisions and action items as bullet points:",
    "error": "Error",
    "summarizeFailed": "Failed to generate summary"
  },
  "formsPage": {
    "title": "Forms",
    "subtitle": "Manage form templates used to collect information from applicants",
    "newTemplate": "New template",
    "newFormName": "New form",
    "archiveConfirm": "Archive this template?",
    "emptyTitle": "No templates yet",
    "emptyHint": "Click \"New template\" to create your first form",
    "fieldCount": "{{count}} fields",
    "archiveAction": "Archive"
  },
  "paymentMilestoneDialog": {
    "amountMinError": "Enter a number of 0 or greater",
    "editTitle": "Edit milestone",
    "addTitle": "Add milestone",
    "typeLabel": "Type",
    "typePlaceholder": "Select a type",
    "percentageLabel": "Percentage (%)",
    "amountLabel": "Amount (JPY)",
    "dueDateLabel": "Due date",
    "sourceLabel": "From",
    "sourceClient": "Client",
    "sourcePartner": "Partner",
    "labelLabel": "Description",
    "labelPlaceholder": "e.g. Consulting fee A$32,331",
    "updateButton": "Update",
    "addButton": "Add"
  },
  "instanceSettings": {
    "invalidEmailFormat": "Invalid email format: {{email}}",
    "invalidSlug": "Slug may contain only lowercase letters, numbers, and hyphens, and must start and end with an alphanumeric character",
    "title": "Public URL Settings",
    "description": "Change the application handling mode, URL slug, and notification emails.",
    "linkModeLabel": "Application Handling Mode",
    "slugLabel": "URL Slug",
    "slugHintPrefix": "Leave blank to use the",
    "slugHintSuffix": "format",
    "notifyEmailsLabel": "Notification Emails",
    "notifyEmailsHint": "A notification email is sent to these addresses when a response is submitted. Separate multiple addresses with commas."
  },
  "aiChat": {
    "systemPrompt": "You are the AI assistant for atsume.camp, a group travel planning platform. You help with itinerary suggestions, estimate optimization, automatic task generation, and participant management advice. Please respond in English. Keep your answers concise and practical.",
    "systemPromptContextLabel": "Here is the current project data:",
    "suggestionImproveItinerary": "Suggest improvements to the itinerary",
    "suggestionOptimizeBudget": "Propose a budget optimization plan",
    "suggestionListTasks": "List out the tasks that need to be done",
    "suggestionDraftPartnerMessage": "Draft a message to the partner",
    "emptyStateDescription": "Ask questions about this project or request tasks",
    "inputPlaceholder": "Type a message...",
    "genericError": "An error occurred",
    "responseFailed": "The AI failed to respond.",
    "close": "Close"
  },
  "landingEditor": {
    "tabHero": "Hero",
    "tabAudiences": "Audiences",
    "tabEvents": "Events",
    "tabLayout": "Layout",
    "tabPublish": "Publish",
    "createPrompt": "Subdomain slug for the new landing (e.g. atsu):",
    "slugInvalid": "Slug must be 2-40 characters, lowercase letters, digits, or hyphens only.",
    "createFailed": "Failed to create: {{message}}",
    "noPermissionTitle": "No permission",
    "noPermissionDescription": "Editing this page requires the tenant administrator (admin) role.",
    "emptyTitle": "No landing pages yet",
    "emptyDescription": "Create the first landing page for this tenant.",
    "new": "New",
    "preview": "Preview",
    "saved": "Saved",
    "previewLoading": "Loading preview..."
  },
  "revenueTab": {
    "modeCogsLabel": "Auto-calculate from cost",
    "modeCogsDesc": "Automatically derive tour prices per category from cost entries",
    "modeParticipantsLabel": "Amount per participant",
    "modeParticipantsDesc": "Sum the per-person amounts set in the Participants tab",
    "modeRoughLabel": "Rough total",
    "modeRoughDesc": "Enter an estimated total revenue at once",
    "participantTotal": "Total for {{count}} participants",
    "participantHint": "Set amounts per person in the Participants tab. The total here becomes your revenue.",
    "roughTitle": "Rough total revenue",
    "roughPlaceholder": "e.g. 1500000",
    "saved": "Saved",
    "roughHint": "For estimates before cost and participant details are finalized."
  },
  "quoteComparison": {
    "title": "Quote comparison",
    "categoryLineItem": "Category / line item",
    "category": {
      "accommodation": "Accommodation",
      "transport": "Transport",
      "content": "Content",
      "meal": "Meals",
      "pmFee": "PM fee",
      "other": "Other"
    }
  },
  "dash": {
    "pipelineFunnel": {
      "title": "Pipeline"
    },
    "morningSummary": {
      "title": "Today's priorities",
      "count": "{{count}}",
      "empty": "Nothing needs attention today. Enjoy a calm morning.",
      "departToday": "Departs today",
      "departInDays": "{{count}} days to departure",
      "paymentDeposit": "Deposit",
      "paymentInterim": "Interim payment",
      "paymentFinal": "Final payment",
      "paymentOverdue": "{{label}} overdue by {{count}} days",
      "paymentDueToday": "{{label}} due today",
      "paymentDueInDays": "{{count}} days until {{label}}",
      "highPriorityTasks": "{{count}} high-priority tasks unfinished",
      "showTop3": "Show top 3 only",
      "showMore": "Show {{count}} more"
    },
    "kpiCards": {
      "revenue": "Projected revenue",
      "revenueSub": "{{count}} camps",
      "pax": "Participants",
      "paxSub": "across {{count}} camps",
      "avgProgress": "Avg. progress",
      "avgProgressSub": "Active camps",
      "attention": "Needs attention",
      "attentionSub": "Within 14 days, under 80% progress"
    },
    "alertBanner": {
      "remindSubject": "[atsume.camp] {{campName}} payment reminder",
      "remindBody": "The payment deadline for {{campName}} is approaching.\n\nDue: {{detail}}\n\nPlease review at your earliest convenience.",
      "remind": "Send reminder",
      "remaining": "{{value}} remaining",
      "viewDetails": "View details",
      "close": "Close"
    },
    "dashboardSummary": {
      "active": "In progress",
      "activeValue": "{{count}}",
      "activeSub": "of {{count}} total",
      "participants": "Total participants",
      "participantsValue": "{{value}}",
      "budget": "Total budget",
      "deadlines": "This month's deadlines",
      "deadlinesValue": "{{count}}"
    },
    "seasonView": {
      "seasonOverview": "Season overview",
      "subtitle": "Review active camps on the timeline. Click a card to open details.",
      "focusSub": "Camps needing attention this week",
      "today": "Today",
      "days": "{{count}}d"
    },
    "kanbanBoard": {
      "title": "Pipeline",
      "subtitle": "Cards grouped by status. At-risk camps show a red countdown.",
      "empty": "No camps"
    },
    "timelineView": {
      "title": "Timeline",
      "status": "Status",
      "destination": "Destination"
    }
  },
  "tenantLanding": {
    "layoutForm": {
      "blockHero": "Hero",
      "blockInfoDashboard": "Info Dashboard",
      "blockRichText": "Rich Text",
      "blockAudienceCategories": "Audience Categories",
      "blockEventList": "Event List",
      "blockCalendar": "Calendar",
      "intro": "Order of the blocks on the page. Hero is usually placed first.",
      "richTextPlaceholder": "# Heading\n\nBody...",
      "filterLabel": "Filter:",
      "showPast": "Show past events too",
      "calendarRangeLabel": "Range:",
      "rangeAll": "All",
      "rangeUpcoming": "Upcoming only",
      "rangePast": "Past only",
      "addSection": "Add"
    },
    "publishPanel": {
      "domainError": "Published flag saved. Error registering CF Pages domain: {{message}}",
      "publishLabel": "Publish",
      "publishHintPrefix": "When ON, served at",
      "publishHintSuffix": ".",
      "publishHintDomain": "The first time, registering the custom domain on Cloudflare Pages can take a few to about 10 minutes.",
      "preview": "Preview",
      "infoTitle": "Info",
      "infoAdminOnly": "Only organization admins can toggle publishing",
      "infoPauseKeepsSettings": "Pausing keeps your settings (turn ON again to restore)",
      "infoDomainOnce": "Domain registration happens only once. Once registered, {{domain}} stays on CF Pages"
    },
    "eventsForm": {
      "intro": "Manually added events. Shown combined with camps from the database. A camp with the same id is overridden.",
      "empty": "No manual entries yet.",
      "idHint": "Matching a camp's id overrides that camp's display",
      "urlLabel": "URL (internal /f/... or external https://...)",
      "heroImageLabel": "Hero image (optional)",
      "addEvent": "Add event"
    },
    "audiencesForm": {
      "intro": "Audience categories (e.g. executives / individuals / companies). The audience tag on each event is chosen from the keys defined here.",
      "empty": "No categories yet. Create one with \"Add\" below.",
      "labelJpPlaceholder": "For executives",
      "addCategory": "Add category"
    },
    "heroForm": {
      "eyebrowHint": "Small label shown above the title (optional)",
      "subtitlePlaceholder": "A one- or two-sentence description",
      "backgroundImageLabel": "Background Image",
      "backgroundImageHint": "Recommended: 1920x1080px / WebP / a darker photo. Also used as the OG image."
    },
    "imageUpload": {
      "errorNotImage": "Please select an image file",
      "errorTooLarge": "Please select a file under 10MB",
      "replace": "Replace",
      "upload": "Upload"
    },
    "infoDashboard": {
      "forWhomSub": "Audience",
      "detail": "Details →",
      "upcomingSub": "Upcoming",
      "upcomingEmpty": "No upcoming sessions published yet",
      "calendarSub": "Schedule"
    },
    "audienceCategories": {
      "intro": "Each category differs in format and intent. Read whichever interests you first.",
      "sessionsEmpty": "No sessions published yet. They will be announced here as they go live."
    },
    "sakurai": {
      "audiencesDivider": "{{count}} categories, each with a different intent.",
      "sessionsDivider": "{{count}} upcoming, ordered by date.",
      "detail": "Details →",
      "calendarHeading": "Schedule"
    },
    "audienceDetail": {
      "notFound": "Plan not found",
      "themesSub": "Themes — what you'll learn / take away",
      "processSub": "Rhythm — the daily, weekly, and monthly flow",
      "outcomesSub": "Where you'll be in 3 months — examples",
      "faqSub": "Frequently asked questions",
      "ctaDefault": "Contact us",
      "ctaSecondaryDefault": "Book"
    },
    "eventDetail": {
      "notFound": "Session not found",
      "applyCta": "View details / Apply",
      "closedTitle": "Closed — this session has ended",
      "closedBody": "Please check the schedule for the next session."
    }
  },
  "misc": {
    "paymentMemos": {
      "title": "Change notes / history",
      "count": "{{count}}",
      "noteTitle": "Payment note",
      "placeholder": "e.g. Party size changed from 25 to 22; final amount recalculated",
      "add": "Add note",
      "empty": "No notes yet. Record a note whenever pricing or terms change.",
      "editedAt": "(edited: {{date}})",
      "deleteConfirm": "Delete this note? This action cannot be undone."
    },
    "aiSidebarPanel": {
      "title": "AI assistant",
      "close": "Close AI assistant",
      "selectCamp": "Select a camp",
      "emptyHintBefore": "Open a camp from the dashboard",
      "emptyHintAfter": "to use the AI assistant",
      "prompt": "Ask a question or request a task",
      "suggestionItinerary": "Suggest improvements to the itinerary",
      "suggestionBudget": "Propose budget optimizations",
      "suggestionTasks": "List the tasks that need doing",
      "inputPlaceholder": "Type a message...",
      "inputLabel": "Message to AI assistant"
    },
    "campOverview": {
      "tabOverview": "Overview",
      "tabItinerary": "Itinerary",
      "tabRevenue": "Revenue",
      "tabParticipants": "Participants",
      "tabPartners": "Partners",
      "tabTasks": "Tasks",
      "tabNotes": "Notes",
      "openDetail": "Open detail",
      "share": "Share"
    },
    "statusChange": {
      "description": "Change the status of this camp.",
      "selectPlaceholder": "Select a new status",
      "currentSuffix": " (current)",
      "backwardWarning": "You are reverting the status. This may affect related data.",
      "confirm": "Change"
    },
    "receiptUpload": {
      "invalidType": "Select an image (PNG/JPEG/WebP) or a PDF",
      "tooLarge": "Select a file under 10MB",
      "uploadFailed": "Upload failed",
      "receipt": "Receipt",
      "removeReceipt": "Remove receipt",
      "replace": "Replace",
      "upload": "Upload receipt"
    },
    "campListItem": {
      "budgetMan": "¥{{value}}0k",
      "budgetYen": "¥{{value}}",
      "pax": "{{count}} pax",
      "deadline": "Due {{date}}"
    },
    "app": {
      "notFound": "Page not found",
      "backToDashboard": "Back to dashboard",
      "unexpectedError": "An unexpected error occurred",
      "reload": "Reload page"
    },
    "publicFormThanks": {
      "line1": "Thank you for your application.",
      "line2": "We will review it and get back to you shortly.",
      "closeNotice": "You may now close this page"
    },
    "qrPopover": {
      "show": "Show QR code",
      "generating": "Generating…"
    },
    "appLayout": {
      "navigation": "Navigation",
      "menu": "Menu"
    },
    "appContext": {
      "syncFailed": "Failed to save data: {{message}}"
    },
    "timeline": {
      "title": "Timeline"
    },
    "dialog": {
      "close": "Close"
    }
  },
  "sidebar": {
    "switchTenant": "Switch tenant",
    "openAi": "Open AI assistant",
    "aiNoCamp": "AI assistant (no camp selected)",
    "aiAssistant": "AI assistant",
    "selectCampPrompt": "Select a camp",
    "selectCampToUseAi": "Select a camp to use the AI assistant",
    "expand": "Expand sidebar",
    "collapseAria": "Collapse sidebar",
    "collapse": "Collapse",
    "profileMenu": "Profile menu",
    "quickTour": "Quick tour",
    "lightMode": "Light mode",
    "darkMode": "Dark mode",
    "logout": "Log out"
  },
  "linkMode": {
    "selection": {
      "label": "Selection-based (register after hiring decision)",
      "description": "A response is an application. Only entries marked \"accepted\" on the Form Responses screen are added as participants."
    },
    "auto": {
      "label": "Direct registration (response = instant participant)",
      "description": "Responses are auto-added to participants (status: registered). Duplicates are detected by email and name."
    },
    "none": {
      "label": "No link (survey only)",
      "description": "Responses are stored only and are not tied to participant management."
    },
    "preEvent": {
      "label": "Pre-event responses (for registered participants)",
      "description": "Not for applications; collects advance information from already-registered participants."
    }
  },
  "alerts": {
    "incompleteTasks": "{{days}} days until start, with {{count}} incomplete tasks",
    "paymentDue": "{{days}} days until payment due ({{label}})",
    "deadlinePayment": "{{label}} payment",
    "paymentType": {
      "deposit": "Deposit",
      "interim": "Interim payment",
      "final": "Final payment"
    }
  },
  "bus": {
    "tab": "Buses",
    "empty": "No bus activities in this itinerary. Add bus entries to the itinerary and the booking list appears here.",
    "dayCount": "{{count}} days with buses",
    "legCount": "{{count}} legs",
    "noTime": "{{count}} without a time",
    "export": "Export CSV",
    "capacity": "Coach type",
    "capacity11": "11 rows (55 incl. jump seats)",
    "capacity12": "12 rows (60 incl. jump seats)",
    "paxAndBuses": "Passengers and coaches",
    "busesFor": "{{pax}} people → {{count}} coaches",
    "paxUnknown": "Passenger count not set",
    "quotedDays": "Days in the quote",
    "quotedShort": "The quote is {{count}} days short",
    "quotedOver": "The quote has {{count}} days too many",
    "quotedMatch": "Matches the itinerary",
    "capacityWarning": "{{pax}} people exceed the {{capacity}}-seat capacity, so {{count}} coaches are needed. Each extra coach costs roughly ¥200,000 per day.",
    "daySpan": "{{span}} on duty",
    "timeTbd": "Time TBD",
    "hint": "This table is derived from the itinerary. Change the itinerary and this changes with it. It can be handed to the agency as-is.",
    "col": {
      "day": "Day",
      "date": "Date",
      "time": "Time",
      "route": "Route / purpose",
      "duration": "Duration",
      "pax": "Passengers",
      "buses": "Coaches",
      "note": "Note"
    },
    "riders": "Passengers",
    "staffNotIncluded": "Leave empty to use the camp participant count ({{pax}}). Staff and coaches are not included.",
    "untypedTransport": "{{count}} transport entries have no mode selected. Choose \"Bus\" for them to appear in this list.",
    "orphans": "{{count}} entries are not attached to any day and do not appear in any list.",
    "untilDate": "(until {{date}})",
    "paxInvalid": "Enter a whole number of 0 or more. Using the camp count for now.",
    "endDateTooLong": "{{count}} bus leg(s) end more than a year after they start. This is likely a typo, so only the start day is counted."
  },
  "travel": {
    "issue": {
      "dobInvalid": "Date of birth is not a valid date ({{value}})",
      "dobFuture": "Date of birth is in the future ({{value}})",
      "dobAfterStart": "Date of birth is after the tour start ({{value}})",
      "dobMissing": "Date of birth is missing",
      "genderMissing": "Gender is missing",
      "romanMissing": "Roman name is missing",
      "nationalityMissing": "Nationality is missing",
      "passportMissing": "Passport number is missing",
      "expiryInvalid": "Passport expiry is not a valid date ({{value}})",
      "expiryBeforeEnd": "Passport expires before the tour ends ({{value}})",
      "expirySoon": "Passport has less than 6 months left after the tour ({{value}})",
      "expiryMissing": "Passport expiry is missing",
      "visaRequired": "A visa may be required ({{value}})",
      "visaConditional": "Conditionally visa-exempt nationality ({{value}})",
      "arrivalMissing": "Arrival flight is missing",
      "departureMissing": "Departure flight is missing",
      "visaUnknown": "Cannot determine visa requirement for \"{{value}}\". Check with the agency",
      "fieldInvalid": "The value of {{value}} is corrupt (not a string)"
    },
    "summary": {
      "title": "Missing travel details",
      "errors": "{{count}} to fix",
      "warnings": "{{count}} to check",
      "flightMissing": "{{count}} without flight details",
      "visaRequired": "{{count}} may need a visa",
      "spelling": "Family name spellings disagree",
      "spellingHint": "Family names differing by 1–2 characters are mixed. If they are the same household, align the spelling (we do not detect households).",
      "ok": "Travel details are complete",
      "showOnlyIssues": "Show only people with gaps",
      "latestArrival": "Latest arrival",
      "departureMissing": "{{count}} without departure details",
      "markInternational": "Treat as an overseas trip",
      "sameRoom": "same room",
      "arrivalGroups": "Arrivals by flight ({{count}})",
      "arrivalTimeUnknown": "Time TBD",
      "people": "{{count}} pax",
      "visaPending": "Visa pending {{count}}"
    }
  },
  "changeFeed": {
    "title": "Recent changes",
    "unseen": "{{count}} since last visit",
    "markSeen": "Mark as seen",
    "loading": "Loading…",
    "failed": "Could not load the change history",
    "empty": "No changes yet",
    "unknownActor": "Someone",
    "showAll": "Show all ({{count}})",
    "showLess": "Show less",
    "line": "{{who}} {{op}} {{entity}}",
    "entity": {
      "activity": "an activity",
      "itinerary_day": "a day",
      "participant": "a participant",
      "comment": "a comment",
      "other": "a record"
    },
    "op": {
      "insert": "added",
      "update": "changed",
      "delete": "deleted"
    },
    "field": {
      "description": "Description",
      "time": "Start",
      "end_time": "End",
      "type": "Type",
      "itinerary_day_id": "Day",
      "day_number": "Day #",
      "date": "Date",
      "theme": "Theme",
      "name": "Name",
      "status": "Status",
      "role": "Role",
      "room_assignment": "Room"
    },
    "moved": "moved to another day",
    "unseenMany": "{{count}}+ since last visit"
  },
  "shareLinks": {
    "open": "Share link",
    "title": "Itinerary share links",
    "description": "Create a link that shows the itinerary without logging in. Internal memos, prices and vendors are never shown. The link stops working when it expires or is revoked.",
    "validFor": "Valid for",
    "days": "{{count}} days",
    "includeNotes": "Include notes",
    "create": "Create link",
    "copy": "Copy",
    "copied": "Copied",
    "revoke": "Revoke",
    "until": "until {{date}}",
    "withNotes": "with notes",
    "none": "No links yet",
    "loadFailed": "Could not load links",
    "createFailed": "Could not create the link",
    "revokeFailed": "Could not revoke the link",
    "copyFailed": "Could not copy. Please select the URL and copy it.",
    "state": {
      "active": "Active",
      "expired": "Expired",
      "revoked": "Revoked"
    }
  },
  "today": {
    "tab": "Today",
    "title": "Today",
    "isToday": "Today",
    "dayChip": "Day {{n}} {{date}}",
    "noDates": "The itinerary has no dates yet. Add a date to each day to use this screen.",
    "schedule": "Schedule",
    "scheduleDay": "Day {{n}} schedule",
    "noActivities": "Nothing scheduled for this day",
    "noTime": "No time",
    "tbd": "(TBC)",
    "arrivals": "Arriving this day",
    "unknownFlight": "No flight no.",
    "people_one": "{{count}} person",
    "people": "{{count}} people",
    "rollCall": "Roll call",
    "presentCount": "{{present}} / {{total}}",
    "refresh": "Refresh",
    "defaultLabel": "Meeting",
    "newLabel": "Roll call name",
    "addLabel": "Add",
    "search": "Search name or room",
    "missingOnly": "Missing only",
    "loadFailed": "Could not load the roll call. Tap refresh once you have signal.",
    "saveFailed": "Could not save. Please tap again.",
    "loading": "Loading…",
    "allPresent": "Everyone is here",
    "noMatch": "No one matches",
    "rooms": "Rooms ({{count}})",
    "show": "Show",
    "hide": "Hide",
    "unassigned": "Unassigned",
    "contacts": "Staff contacts"
  },
  "headcount": {
    "title": "Headcount over time",
    "show": "Show",
    "hide": "Hide",
    "loading": "Loading…",
    "failed": "Could not load the history",
    "noChanges": "No additions or removals since tracking began (now {{count}})",
    "endOfDay": "{{count}} at end of day",
    "unknownName": "(no name)",
    "since": "Tracked from {{date}}; {{count}} just before",
    "truncated": "Older history omitted ({{count}} just before {{date}})",
    "truncatedNoDate": "Older history omitted",
    "unknownActor": "unknown",
    "syncing": "Some changes are still saving; the count will update once they are saved"
  },
  "disclosure": {
    "field": "Told the client?",
    "unset": "Not set",
    "internal": "Internal only",
    "partial": "Partly told",
    "shared": "Told",
    "internalHint": "Hidden from the shared itinerary link and from PDFs without internal notes.",
    "noteLabel": "What has not been told",
    "notePlaceholder": "e.g. price not told yet / separate Tokyo hotel not mentioned",
    "undisclosed": "{{count}} not fully told",
    "undisclosedHint": "Items marked internal only or partly told.",
    "pdfExcluded": "{{count}} internal-only activities are left out when internal notes are not included.",
    "undisclosedBreakdown": "activities: {{activities}}, quotes: {{quotes}}, rooming: {{rooming}}",
    "exportConfirm": {
      "internal": "This is marked internal only. Export it anyway?{{note}}",
      "partial": "This is only partly told to the client. Check what is not told yet. Export anyway?{{note}}"
    },
    "internalFileTag": "internal-only"
  },
  "addPax": {
    "title": "Can we take one more?",
    "description": "Checks the rooms held, the bus and the quote you already have.",
    "addLabel": "Add",
    "people": "{{count}}",
    "segmentLabel": "Segment",
    "rooms": "Rooms",
    "roomsUnknown": "No held-rooms note on this camp, so this cannot be judged.",
    "roomsFit": "Fits in what is held ({{tightest}}: {{free}} free of {{reserved}} beds)",
    "roomsShort": "{{shortfall}} beds short ({{tightest}}: {{free}} free of {{reserved}} beds)",
    "bus": "Bus",
    "busSame": "Still {{before}} bus(es) (capacity {{capacity}})",
    "busMore": "{{extra}} more bus(es) ({{before}} → {{after}}, capacity {{capacity}})",
    "cost": "Cost",
    "costUnknown": "The quote has no per-person price for this segment.",
    "costDelta": "{{total}} more ({{perPerson}} per person)",
    "footer": "{{before}} → {{after}} people. The bus cost itself is in the quote; this only counts vehicles.",
    "segment": {
      "adult": "Adult",
      "adult_2": "Adult (2)",
      "child": "Child",
      "infant": "Infant",
      "other": "Other"
    }
  },
  "tax": {
    "title": "Tax",
    "undecided": "Not decided",
    "excl": "Tax excluded",
    "incl": "Tax included",
    "quoteLabel": "Quote v{{version}}",
    "quoteLabelNone": "Quote (none yet)",
    "invoiceLabel": "Invoice",
    "invoiceYes": "Required",
    "invoiceNo": "Not required",
    "noteLabel": "Tax note",
    "notePlaceholder": "e.g. agreed tax-exclusive with the agency, confirming with the accountant",
    "unknown": "{{count}} amounts with no tax basis",
    "unknownHint": "Amounts where tax-exclusive vs tax-inclusive is undecided. Getting it wrong changes what you keep.",
    "breakdown": "quote: {{quote}}, lines: {{items}}, costs: {{costs}}, payments: {{payments}}",
    "alignCosts": "{{count}} cost rows undecided",
    "alignPayments": "{{count}} payments undecided",
    "alignTo": "Set to {{mode}}"
  },
  "decisions": {
    "title": "Decisions",
    "add": "Add a decision",
    "save": "Save",
    "empty": "No decisions recorded yet.",
    "failed": "Could not load or save decisions.",
    "untold": "{{count}} not shared",
    "notShared": "Not shared",
    "decidedOn": "Decided on",
    "decidedBy": "Decided by",
    "decidedByPlaceholder": "e.g. Awata / weekly with Nishitetsu",
    "titleLabel": "What was decided",
    "titlePlaceholder": "e.g. the shinkansen fare is inside the 3,850",
    "detail": "Breakdown / notes",
    "detailPlaceholder": "e.g. 1,200 rail + 2,650 hotel",
    "source": "Where the evidence is",
    "sourcePlaceholder": "e.g. minutes URL / LINE 6-25",
    "sharedWith": "Shared with",
    "sharedWithPlaceholder": "e.g. Nishitetsu, Gerard",
    "sharedWithValue": "Shared with {{who}}",
    "delete": "Delete"
  },
  "staffSection": {
    "title": "Staff",
    "add": "Assign",
    "modeNew": "Add new",
    "modeExisting": "Pick from roster",
    "name": "Name",
    "namePlaceholder": "e.g. Taro Yamada",
    "role": "Role",
    "rolePlaceholder": "e.g. Coach",
    "pickExisting": "Choose staff",
    "pickExistingPlaceholder": "Select one",
    "roleDescription": "Role on this camp (optional)",
    "roleDescriptionPlaceholder": "e.g. Roll call lead",
    "daysLabel": "Days accompanying (unselected = every day)",
    "alwaysAccompanying": "Every day",
    "specificDays": "{{count}} day(s) only",
    "save": "Save",
    "empty": "No staff assigned yet.",
    "failed": "Couldn't load or save staff.",
    "remove": "Unassign"
  },
  "reconciliation": {
    "title": "Received payments",
    "hint": "Record each payment that reached our account and choose which expected payment it covers. The total becomes \"Received\" on the P&L tab.",
    "milestone": "Applies to",
    "overallPct": "{{pct}}% received",
    "billedReceived": "billed {{billed}} · received {{received}}",
    "short": "{{amount}} short",
    "over": "{{amount}} over",
    "addReceipt": "Record a receipt",
    "receivedOn": "Received on",
    "amount": "Amount (JPY)",
    "amountPlaceholder": "e.g. 2400630",
    "foreignCurrency": "Currency",
    "foreignCurrencyPlaceholder": "e.g. AUD",
    "foreignAmount": "Sender amount",
    "foreignAmountPlaceholder": "e.g. 23219",
    "note": "Note",
    "notePlaceholder": "e.g. misread the last 3 digits",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "noMilestones": "No milestones yet.",
    "unassigned": "{{count}} receipts not assigned to a milestone",
    "failed": "Could not load or save receipts."
  },
  "settlement": {
    "otherUnassignedTitle": "Unassigned spend that is not a reimbursement ({{count}})",
    "otherUnassignedLead": "Invoices from email or CSV imports that have no budget line yet. Pick a line to count it in 収益管理. Reimbursements are assigned in each person’s list above.",
    "title": "Settlement",
    "lead": "What we owe each person who paid on our behalf or travelled with the tour. Open a row to see the receipts.",
    "statTotal": "Total to pay back",
    "statWaiting": "Awaiting approval",
    "statCheck": "Needs a look",
    "statClosed": "Receipts complete",
    "countValue": "{{count}}",
    "empty": "No reimbursements or staff fees on this camp yet.",
    "unknownTitle": "Waiting to hear who paid",
    "unknownLead": "Receipts where we do not know yet who paid or whether we pay it back.",
    "noName": "No name",
    "closed": "Receipts complete",
    "notClosed": "Receipts open",
    "waitingN": "{{count}} awaiting approval",
    "checkN": "{{count}} to check",
    "breakdownAdvanced": "Paid {{amount}} ({{count}})",
    "breakdownFee": "Fee {{amount}}",
    "feeMissing": "Fee not set",
    "noReceipts": "No receipts yet.",
    "noImage": "No image",
    "list": {
      "colDate": "Date",
      "colVendor": "Payee",
      "colContent": "Description",
      "colAmount": "Amount",
      "colAttachment": "Attachment",
      "colStatus": "Status",
      "colBudget": "Budget line",
      "receipt": "Receipt",
      "noAttachment": "None",
      "needsApproval": "Needs approval ({{count}})",
      "approved": "Approved / auto-approved ({{count}})",
      "rejected": "Rejected / excluded ({{count}})",
      "selectAll": "Select all",
      "selectRow": "Select this item",
      "selectedPrefix": "Selected items ({{count}}):",
      "bulkBudget": "Budget line to assign",
      "bulkBudgetPick": "Choose a budget line…",
      "bulkAssign": "Assign selected",
      "bulkApprove": "Approve selected ({{count}})",
      "unassigned": "Unassigned",
      "toUnassigned": "Set to unassigned",
      "cogs": "Cost of sales",
      "opex": "SG&A",
      "unknownLine": "(line not in this project)",
      "budgetSaveFailed": "Could not save the budget line. Please try again shortly.",
      "kind": "Cost of sales or SG&A",
      "kindSaveFailed": "Could not save cost of sales / SG&A. Please try again later.",
      "bulkApproveNone": "None of the selected items are awaiting approval."
    },
    "chip": {
      "waiting": "Awaiting approval",
      "check": "Check",
      "auto": "Auto-approved",
      "approved": "Approved",
      "confirmed": "Confirmed",
      "rejected": "Rejected",
      "excluded": "Excluded"
    },
    "noTitle": "(no description)",
    "amountUnknown": "Amount unknown",
    "state": {
      "confirmed": "Confirmed",
      "waiting": "Awaiting approval",
      "check": "Check",
      "rejected": "Not reimbursed"
    },
    "approve": "Approve",
    "reject": "Reject",
    "approveAll": "Approve all {{count}}",
    "changeToReject": "Reject instead",
    "changeToApprove": "Approve instead",
    "checkFirst": "Check the amount or the reading before approving.",
    "approvedBy": "Approved by {{who}} {{date}}",
    "rejectedBy": "Rejected by {{who}} {{date}}",
    "decideFailed": "Could not save. Please try again.",
    "skip": {
      "not_found": "Some receipts were not found.",
      "not_admin": "Only admins can approve.",
      "not_due": "Some are not reimbursements.",
      "self": "Someone else approves what you paid yourself.",
      "not_ready": "Some still need their reading checked.",
      "no_amount": "Receipts without an amount cannot be approved."
    },
    "deadline": "Settlement due {{date}} (10 business days after {{end}})",
    "feeLine": "Fee: {{rate}} × {{days}} days",
    "feeNotSet": "Daily rate and days are not set yet.",
    "notAssigned": "Not assigned to this tour as staff.",
    "editFee": "Set rate and days",
    "assignWithFee": "Assign with a daily rate",
    "dailyRate": "Daily rate",
    "attendDays": "Days",
    "saveFee": "Save",
    "cancel": "Cancel",
    "saveFailed": "Could not save. Please try again.",
    "addStaffTitle": "Add tour staff",
    "addStaffPick": "Pick a partner",
    "status": {
      "confirming": "Awaiting confirmation",
      "disputed": "Says it is wrong",
      "agreed": "Agreed, invoice next",
      "invoice_submitted": "Invoice submitted",
      "paid": "Paid"
    },
    "invoiceMethod": {
      "generate": "Invoice: generated",
      "upload": "Invoice: own file",
      "email": "Invoice: by email"
    },
    "changeFee": "Change rate and days",
    "wholeNumber": "Daily rate: whole number from 0 (up to 9,999,999). Days: in steps of 0.5 (up to 366). No negatives.",
    "listFile": "expense-list",
    "downloadAll": "Download expense list (everyone, CSV)",
    "downloadPerson": "This person's expense list (CSV)",
    "editReceipt": "Edit",
    "noReceipt": {
      "add": "Add without a receipt (lost etc.)",
      "lead": "Adds an advance the person reported, without a receipt. It is paid back to this person and needs approval because there is no receipt.",
      "date": "Paid on",
      "category": "Type",
      "what": "What (e.g. parking 10/17–18)",
      "amount": "Amount (JPY)",
      "save": "Add",
      "cancel": "Cancel",
      "failed": "Could not add it. Please try again.",
      "unassigned": "Added, but it could not be set as this person's advance. Adding it again would double it, so please check the row on the expenses tab.",
      "cat": {
        "transport": "Transport",
        "meal": "Meals",
        "accommodation": "Lodging",
        "other": "Other"
      }
    },
    "ask": {
      "button": "Ask",
      "sent": "Asked (see replies on HiAsh)",
      "label": "Sent to the person who paid, on HiAsh (WhatsApp)",
      "prefill": "A question about the receipt {{about}}: ",
      "send": "Send",
      "failed": "Could not confirm it was sent. Check the HiAsh page."
    },
    "remind": {
      "title": "Reminders and missing submissions",
      "schedule": "Reminder days: {{days}}",
      "today": "Today is reminder #{{n}}",
      "next": "Next: {{date}}",
      "overdue": "{{count}} people have not finished submitting and the deadline has passed",
      "notClosed": "Not finished submitting: {{names}}",
      "allClosed": "Everyone on the tour has finished submitting.",
      "copy": "Copy the reminder"
    },
    "payDay": "Pay on {{date}}",
    "invoiceFromPage": "Invoice sent from the confirm page",
    "openInvoice": "Open invoice",
    "payDayRule": "Invoices received by the 15th are paid at month end; later ones at the end of next month",
    "link": {
      "answeredDone": "Confirmed by them {{date}}",
      "answeredDisputed": "Disputed {{date}}",
      "disputeNote": "They said something is wrong or missing: {{note}}",
      "noNote": "(no note)",
      "joinLegend": "Also show on the same page",
      "flagged": "{{count}} flagged",
      "flagTitle": "Receipts they flagged as wrong",
      "resolve": "Handled",
      "resolveFailed": "Could not record it. Please try again."
    },
    "copySettleLink": "Copy “Is that all for this tour?” (with confirm link)",
    "settleLinkFailed": "Could not create the confirm link. Please try again.",
    "confirmMessage": "After-tour confirmation message",
    "beforeSending": "Before sending: {{what}}",
    "copyMessage": "Copy message",
    "copied": "Copied",
    "copyFailed": "Could not copy. Select the text above and copy it.",
    "blocker": {
      "waiting": "{{count}} awaiting approval",
      "check": "{{count}} to check",
      "fee": "Daily rate and days are not set"
    },
    "labelOnly": "{{count}} receipts known only by a WhatsApp name. Pick the partner who paid to approve them.",
    "advancer": "Paid by",
    "advancerPick": "Who paid",
    "markDue": "We pay it back",
    "markNone": "Not owed (settled)",
    "assignResult": "{{auto}} auto-approved, {{rest}} need approval.",
    "autoApproved": "Auto-approved (rule v{{version}})",
    "assignSkip": {
      "not_found": "Some receipts were not found.",
      "not_allowed": "Only admins and PMs can set this.",
      "decided": "Approved or rejected ones were left as they are.",
      "partner_not_found": "That partner was not found."
    },
    "rulesTitle": "Auto-approval rule",
    "rulesLine": "Auto-approved when ≤ {{limit}} yen incl. tax, {{categories}}, within {{margin}} day(s) of the tour (rule v{{version}}). Otherwise an admin approves.",
    "notifyTitle": "Pending-approval reminder (Accounting Bot)",
    "notifyNoSlack": "Slack is not connected. Connect it in Settings to choose.",
    "notifyOff": "Do not notify",
    "notifyNeedsInvite": " (invite the bot)",
    "notifySaved": "Saved.",
    "notifyAdminOnly": "Could not save (admins only).",
    "notifyLead": "Approve on this tab under \"Needs approval\". If a destination is chosen, a weekday 9:00 (Tokyo) message says how many expenses are waiting, per tour, with a link here (nothing is sent on days with none).",
    "statusLabel": "Settlement status",
    "statusNone": "Not sent yet",
    "invoiceMethodLabel": "Invoice method",
    "invoiceMethodNone": "Invoice: not decided",
    "receiptsClosedLabel": "Receipts complete",
    "statusSaveFailed": "Could not save (admins only).",
    "saveStatus": "Save status",
    "days": {
      "needTitle": "Needs approval: days on tour (self-reported)",
      "approvedTitle": "Days on tour (self-reported) · approved",
      "line": "{{days}} days",
      "half": " (half)",
      "approve": "Approve days",
      "approveFailed": "Could not approve. Reload and try again.",
      "confirmTitle": "Days to confirm with Kazuya",
      "confirmLead": "Every tour member has sent an invoice. Copy this to Kazuya, and approve each person’s days once he says OK. If a count is wrong, ask that person to fix the invoice.",
      "copy": "Copy message",
      "copied": "Copied"
    },
    "feeRateOnly": "Daily rate {{rate}} (days are asked after the tour)",
    "invoiceEmail": {
      "title": "Email address for invoices",
      "lead": "Where tour members send their invoice when they choose “Send by email” on the confirm page. Leave empty to hide that option.",
      "failed": "Could not save. Check the address (admins only).",
      "save": "Save address"
    }
  },
  "hiash": {
    "title": "HiAsh (WhatsApp)",
    "lead": "Each staff member's exchange with HiAsh, the WhatsApp Tour Desk, and replies from here (sent from the HiAsh number). Receipts sent on WhatsApp link to this tour's reimbursement rows.",
    "reload": "Reload",
    "loading": "Loading…",
    "people": "Staff",
    "pick": "Pick a person to see the exchange.",
    "noStaff": "Nobody is in the staff group yet.",
    "noMessages": "No messages yet",
    "desk": "HiAsh",
    "photo": "Photo",
    "file": "File",
    "other": "(sticker etc.)",
    "back": "Back to the list",
    "receipt": "Reimbursement {{amount}} on this tour → Settlement",
    "amountUnknown": "amount unknown",
    "error": {
      "forbidden": "Only admins can see this page.",
      "not_configured": "The HiAsh connection is not set up yet.",
      "unavailable": "Could not load the WhatsApp exchange. Wait a moment and press Reload."
    },
    "fromCamp": "From Camp ({{who}})",
    "replyLabel": "Reply to {{name}} on WhatsApp",
    "replyNote": "Sent from the HiAsh number, to this person only.",
    "send": "Send",
    "sending": "Sending…",
    "sendUnknown": "Could not confirm it was sent. Reload the thread and send again only if it is not there.",
    "openTitle": "{{count}} to handle",
    "openLead": "Staff messages the bot does not answer (amount corrections, lost receipts, questions). Decide, reply or fix it on the settlement tab, then mark it handled. A reply alone does not clear it.",
    "openThread": "Open thread",
    "markHandled": "Handled",
    "markFailed": "Could not mark it handled. Please try again.",
    "needsReply": "To handle",
    "needsReplyCount": "{{count}} to handle",
    "handledBy": "Handled ({{who}})",
    "fixInSettlement": "Fix on settlement tab"
  }
}
